import { useState, useEffect, useCallback } from 'react';
import config from '../config';

// Sample data that would typically come from an API
const sampleReservations = [
  {
    id: 'RES001',
    clientId: 1,
    clientNom: 'Ahmed Benali',
    clientEmail: 'ahmed.benali@email.com',
    destination: 'Istanbul, Turquie',
    forfait: 'Circuit Découverte Istanbul',
    forfaitId: 1,
    dateDepart: '2024-03-15',
    dateRetour: '2024-03-22',
    nombrePassagers: 2,
    prixUnitaire: 85000,
    prixTotal: 170000, // 85000 × 2 = 170000
    acompte: 55500,
    statut: 'Confirmée',
    statutPaiement: 'Acompte versé',
    dateReservation: '2024-01-20',
    notes: 'Demande chambre vue mer'
  },
  {
    id: 'RES002', 
    clientId: 2,
    clientNom: 'Fatima Khadra',
    clientEmail: 'fatima.khadra@email.com',
    destination: 'Dubaï, EAU',
    forfait: 'Séjour Luxe Dubaï',
    forfaitId: 2,
    dateDepart: '2024-02-28',
    dateRetour: '2024-03-07',
    nombrePassagers: 4,
    prixUnitaire: 160000,
    prixTotal: 640000, // 160000 × 4 = 640000
    acompte: 210000,
    statut: 'En attente',
    statutPaiement: 'En attente',
    dateReservation: '2024-01-25',
    notes: 'Voyage famille avec enfants'
  },
  {
    id: 'RES003',
    clientId: 3,
    clientNom: 'Karim Mansouri',
    clientEmail: 'karim.mansouri@email.com',
    destination: 'Paris, France',
    forfait: 'Week-end Romantique Paris',
    forfaitId: 3,
    dateDepart: '2024-02-14',
    dateRetour: '2024-02-17',
    nombrePassagers: 2,
    prixUnitaire: 72500,
    prixTotal: 145000, // 72500 × 2 = 145000
    acompte: 145000,
    statut: 'Terminée',
    statutPaiement: 'Soldé',
    dateReservation: '2024-01-10',
    notes: 'Voyage de noces'
  },
  {
    id: 'RES004',
    clientId: 4,
    clientNom: 'Amina Bouzid',
    clientEmail: 'amina.bouzid@email.com',
    destination: 'Mecca, Arabie Saoudite',
    forfait: 'Pèlerinage Omra Premium',
    forfaitId: 4,
    dateDepart: '2024-04-10',
    dateRetour: '2024-04-20',
    nombrePassagers: 1,
    prixUnitaire: 120000,
    prixTotal: 120000, // 120000 × 1 = 120000
    acompte: 120000,
    statut: 'Confirmée',
    statutPaiement: 'Soldé',
    dateReservation: '2024-02-05',
    notes: 'Premier pèlerinage'
  },
  {
    id: 'RES005',
    clientId: 5,
    clientNom: 'Youssef Meziane',
    clientEmail: 'youssef.meziane@email.com',
    destination: 'Marrakech, Maroc',
    forfait: 'Escapade Marrakech',
    forfaitId: 6,
    dateDepart: '2024-03-25',
    dateRetour: '2024-03-29',
    nombrePassagers: 2,
    prixUnitaire: 67000,
    prixTotal: 134000, // 67000 × 2 = 134000
    acompte: 50000,
    statut: 'Confirmée',
    statutPaiement: 'Acompte versé',
    dateReservation: '2024-02-10',
    notes: 'Demande riad avec piscine'
  },
  {
    id: 'RES006',
    clientId: 2,
    clientNom: 'Fatima Khadra',
    clientEmail: 'fatima.khadra@email.com',
    destination: 'Rome, Italie',
    forfait: 'Circuit Historique Rome',
    forfaitId: 5,
    dateDepart: '2024-05-12',
    dateRetour: '2024-05-18',
    nombrePassagers: 2,
    prixUnitaire: 95000,
    prixTotal: 190000, // 95000 × 2 = 190000
    acompte: 100000,
    statut: 'Confirmée',
    statutPaiement: 'Acompte versé',
    dateReservation: '2024-03-01',
    notes: 'Demande visite guidée Colisée'
  }
];

const sampleClients = [
  {
    id: 1,
    nom: 'Benali',
    prenom: 'Ahmed',
    email: 'ahmed.benali@email.com',
    telephone: '+213 555 123 456',
    adresse: 'Alger, Algérie',
    niveauFidelite: 'Premium',
    preferencesVoyage: ['Culturel', 'Business']
  },
  {
    id: 2,
    nom: 'Khadra',
    prenom: 'Fatima',
    email: 'fatima.khadra@email.com',
    telephone: '+213 555 234 567',
    adresse: 'Oran, Algérie',
    niveauFidelite: 'Standard',
    preferencesVoyage: ['Familial', 'Culturel']
  },
  {
    id: 3,
    nom: 'Mansouri',
    prenom: 'Karim',
    email: 'karim.mansouri@email.com',
    telephone: '+213 555 345 678',
    adresse: 'Constantine, Algérie',
    niveauFidelite: 'Bronze',
    preferencesVoyage: ['Aventure']
  },
  {
    id: 4,
    nom: 'Bouzid',
    prenom: 'Amina',
    email: 'amina.bouzid@email.com',
    telephone: '+213 555 456 789',
    adresse: 'Annaba, Algérie',
    niveauFidelite: 'Premium',
    preferencesVoyage: ['Religieux', 'Culturel']
  },
  {
    id: 5,
    nom: 'Meziane',
    prenom: 'Youssef',
    email: 'youssef.meziane@email.com',
    telephone: '+213 555 567 890',
    adresse: 'Tlemcen, Algérie',
    niveauFidelite: 'Standard',
    preferencesVoyage: ['Détente', 'Familial']
  }
];

const samplePackages = [
  {
    id: 1,
    titre: 'Circuit Découverte Istanbul',
    destination: 'Istanbul, Turquie',
    prix: 85000,
    duree: '7 jours / 6 nuits',
    categorie: 'Culturel',
    inclusions: [], // Remove hardcoded inclusions
    maxPersonnes: 15,
    statut: 'Actif',
    description: 'Découvrez les merveilles d\'Istanbul, entre Orient et Occident. Visitez les sites historiques majeurs et imprégnez-vous de la culture turque.'
  },
  {
    id: 2,
    titre: 'Séjour Luxe Dubaï',
    destination: 'Dubaï, EAU',
    prix: 160000,
    duree: '5 jours / 4 nuits',
    categorie: 'Business',
    inclusions: [], // Remove hardcoded inclusions
    maxPersonnes: 10,
    statut: 'Actif',
    description: 'Séjour de luxe à Dubaï, avec hébergement dans les meilleurs hôtels, accès VIP aux attractions les plus prisées et expériences exclusives.'
  },
  {
    id: 3,
    titre: 'Week-end Romantique Paris',
    destination: 'Paris, France',
    prix: 72500,
    duree: '3 jours / 2 nuits',
    categorie: 'Romantique',
    inclusions: ['Vol A/R', 'Hôtel 4*', 'Dîner Tour Eiffel'],
    maxPersonnes: 2,
    statut: 'Actif',
    description: 'Week-end romantique dans la ville lumière. Profitez d\'un dîner sur la Tour Eiffel, d\'une croisière sur la Seine et découvrez les lieux les plus romantiques de Paris.'
  },
  {
    id: 4,
    titre: 'Pèlerinage Omra Premium',
    destination: 'Mecca, Arabie Saoudite',
    prix: 120000,
    duree: '10 jours / 9 nuits',
    categorie: 'Religieux',
    inclusions: ['Vol A/R', 'Hôtel 5*', 'Guide spirituel'],
    maxPersonnes: 30,
    statut: 'Actif',
    description: 'Pèlerinage Omra dans les meilleures conditions, avec guide spirituel personnel et hébergement premium à proximité des lieux saints.'
  },
  {
    id: 5,
    titre: 'Circuit Historique Rome',
    destination: 'Rome, Italie',
    prix: 95000,
    duree: '6 jours / 5 nuits',
    categorie: 'Culturel',
    inclusions: ['Vol A/R', 'Hôtel 4*', 'Visites guidées'],
    maxPersonnes: 15,
    statut: 'Actif',
    description: 'Voyage dans le temps à travers la Rome Antique. Découvrez le Colisée, le Forum Romain, le Vatican et les trésors de la Rome Renaissance.'
  },
  {
    id: 6,
    titre: 'Escapade Marrakech',
    destination: 'Marrakech, Maroc',
    prix: 67000,
    duree: '4 jours / 3 nuits',
    categorie: 'Culturel',
    inclusions: ['Vol A/R', 'Riad traditionnel', 'Excursions'],
    maxPersonnes: 12,
    statut: 'Actif',
    description: 'Plongez dans l\'atmosphère des souks, découvrez la médina de Marrakech et les jardins de Majorelle. Séjour dans un authentique riad avec expérience hammam.'
  }
];

const sampleFinancialData = [
  {
    id: 'TXN001',
    type: 'Recette',
    categorie: 'Reservation',
    montant: 55500,
    date: '2024-01-20',
    client: 'Ahmed Benali',
    clientId: 1,
    reservation: 'RES001',
    description: 'Acompte réservation Istanbul',
    statut: 'Confirmé',
    modePaiement: 'Carte bancaire'
  },
  {
    id: 'TXN002',
    type: 'Recette',
    categorie: 'Reservation',
    montant: 210000,
    date: '2024-01-25',
    client: 'Fatima Khadra',
    clientId: 2,
    reservation: 'RES002',
    description: 'Acompte réservation Dubaï',
    statut: 'En attente',
    modePaiement: 'Virement bancaire'
  },
  {
    id: 'TXN003',
    type: 'Recette',
    categorie: 'Reservation',
    montant: 172550,
    date: '2024-01-10',
    client: 'Karim Mansouri',
    clientId: 3,
    reservation: 'RES003',
    description: 'Paiement complet Paris',
    statut: 'Confirmé',
    modePaiement: 'Carte bancaire'
  },
  {
    id: 'TXN004',
    type: 'Recette',
    categorie: 'Reservation',
    montant: 129800,
    date: '2024-02-05',
    client: 'Amina Bouzid',
    clientId: 4,
    reservation: 'RES004',
    description: 'Paiement complet Omra',
    statut: 'Confirmé',
    modePaiement: 'Espèces'
  },
  {
    id: 'TXN005',
    type: 'Recette',
    categorie: 'Reservation',
    montant: 50000,
    date: '2024-02-10',
    client: 'Youssef Meziane',
    clientId: 5,
    reservation: 'RES005',
    description: 'Acompte Marrakech',
    statut: 'Confirmé',
    modePaiement: 'Carte bancaire'
  },
  {
    id: 'TXN006',
    type: 'Recette',
    categorie: 'Reservation',
    montant: 100000,
    date: '2024-03-01',
    client: 'Fatima Khadra',
    clientId: 2,
    reservation: 'RES006',
    description: 'Acompte Rome',
    statut: 'Confirmé',
    modePaiement: 'Virement bancaire'
  }
];

// Sample suppliers data that would typically come from an API
const sampleSuppliers = [
  {
    id: 'FOUR001',
    nom: 'Air Algérie',
    type: 'Compagnie aérienne',
    pays: 'Algérie',
    ville: 'Alger',
    email: 'partenaires@airalgerie.dz',
    telephone: '+213 21 98 98 98',
    adresse: 'Aéroport Houari Boumediene, Alger',
    statut: 'Actif',
    note: 4.2,
    nombreServices: 45,
    montantContrats: 850000,
    datePartenariat: '2020-03-15',
    personneContact: 'Karim Benaissa',
    commission: 8,
    delaiPaiement: 30,
    description: 'Compagnie aérienne nationale algérienne offrant des vols domestiques et internationaux',
    avatar: 'https://ui-avatars.com/api/?name=Air+Algerie&background=1976d2&color=fff',
    categoriePrincipale: 'Transport aérien'
  },
  {
    id: 'FOUR002',
    nom: 'Hotel El Aurassi',
    type: 'Hôtel',
    pays: 'Algérie',
    ville: 'Alger',
    email: 'reservations@elaurassi.dz',
    telephone: '+213 23 74 82 52',
    adresse: '1 Avenue du Docteur Frantz Fanon, Alger',
    statut: 'Actif',
    note: 4.5,
    nombreServices: 28,
    montantContrats: 320000,
    datePartenariat: '2019-08-20',
    personneContact: 'Amira Chetouane',
    commission: 12,
    delaiPaiement: 15,
    description: 'Hôtel de luxe 5 étoiles au cœur d\'Alger avec vue sur la baie',
    avatar: 'https://ui-avatars.com/api/?name=El+Aurassi&background=2e7d32&color=fff',
    categoriePrincipale: 'Hébergement'
  },
  {
    id: 'FOUR003',
    nom: 'Turkish Airlines Tours',
    type: 'Compagnie aérienne',
    pays: 'Turquie',
    ville: 'Istanbul',
    email: 'algeria@turkishairlines.com',
    telephone: '+90 212 444 0 849',
    adresse: 'Aéroport Istanbul, Turquie',
    statut: 'Actif',
    note: 4.7,
    nombreServices: 67,
    montantContrats: 1250000,
    datePartenariat: '2018-12-10',
    personneContact: 'Mehmet Özkan',
    commission: 10,
    delaiPaiement: 45,
    description: 'Compagnie aérienne internationale turque avec un large réseau mondial',
    avatar: 'https://ui-avatars.com/api/?name=Turkish+Airlines&background=e74c3c&color=fff',
    categoriePrincipale: 'Transport aérien international'
  },
  {
    id: 'FOUR004',
    nom: 'Transport Safar',
    type: 'Transport',
    pays: 'Algérie',
    ville: 'Oran',
    email: 'contact@transportsafar.dz',
    telephone: '+213 41 55 44 33',
    adresse: 'Zone industrielle Es-Senia, Oran',
    statut: 'Actif',
    note: 4.1,
    nombreServices: 22,
    montantContrats: 180000,
    datePartenariat: '2021-06-05',
    personneContact: 'Omar Benali',
    commission: 6,
    delaiPaiement: 7,
    description: 'Entreprise de transport touristique avec une flotte moderne et climatisée',
    avatar: 'https://ui-avatars.com/api/?name=Transport+Safar&background=ed6c02&color=fff',
    categoriePrincipale: 'Transport terrestre'
  },
  {
    id: 'FOUR005',
    nom: 'Emirates Premium Travel',
    type: 'Compagnie aérienne',
    pays: 'EAU',
    ville: 'Dubaï',
    email: 'algeria@emirates.com',
    telephone: '+971 4 214 4444',
    adresse: 'Aéroport International de Dubaï, EAU',
    statut: 'Actif',
    note: 4.8,
    nombreServices: 89,
    montantContrats: 2100000,
    datePartenariat: '2017-09-30',
    personneContact: 'Ahmed Al-Mansouri',
    commission: 12,
    delaiPaiement: 60,
    description: 'Compagnie aérienne de luxe des Émirats Arabes Unis',
    avatar: 'https://ui-avatars.com/api/?name=Emirates&background=c0392b&color=fff',
    categoriePrincipale: 'Aviation luxe'
  },
  {
    id: 'FOUR006',
    nom: 'Marrakech Authentic',
    type: 'Hôtel',
    pays: 'Maroc',
    ville: 'Marrakech',
    email: 'contact@riadmarrakechpalace.ma',
    telephone: '+212 524 38 40 40',
    adresse: 'Médina, Marrakech, Maroc',
    statut: 'Actif',
    note: 4.4,
    nombreServices: 18,
    montantContrats: 145000,
    datePartenariat: '2020-11-12',
    personneContact: 'Fatima Alaoui',
    commission: 15,
    delaiPaiement: 10,
    description: 'Riad traditionnel authentique dans la médina de Marrakech',
    avatar: 'https://ui-avatars.com/api/?name=Marrakech&background=ff9800&color=fff',
    categoriePrincipale: 'Hébergement authentique'
  },
  {
    id: 'FOUR007',
    nom: 'Paris Romantique Tours',
    type: 'Tour opérateur',
    pays: 'France',
    ville: 'Paris',
    email: 'partenaires@voyageplus.fr',
    telephone: '+33 1 44 56 78 90',
    adresse: '123 Avenue des Champs-Élysées, Paris',
    statut: 'Suspendu',
    note: 3.8,
    nombreServices: 12,
    montantContrats: 75000,
    datePartenariat: '2019-04-18',
    personneContact: 'Jean Dubois',
    commission: 20,
    delaiPaiement: 30,
    description: 'Tour opérateur spécialisé dans les voyages romantiques à Paris',
    avatar: 'https://ui-avatars.com/api/?name=Paris+Tours&background=e91e63&color=fff',
    categoriePrincipale: 'Circuits romantiques'
  },
  {
    id: 'FOUR008',
    nom: 'Al Masjid Travel',
    type: 'Tour opérateur',
    pays: 'Arabie Saoudite',
    ville: 'La Mecque',
    email: 'info@almasjidtravel.sa',
    telephone: '+966 12 534 5678',
    adresse: 'Quartier Ajyad, La Mecque, Arabie Saoudite',
    statut: 'Actif',
    note: 4.6,
    nombreServices: 35,
    montantContrats: 290000,
    datePartenariat: '2021-01-20',
    personneContact: 'Abdullah Al-Harbi',
    commission: 18,
    delaiPaiement: 14,
    description: 'Spécialiste des pèlerinages Omra et Hajj avec services premium',
    avatar: 'https://ui-avatars.com/api/?name=Al+Masjid&background=27ae60&color=fff',
    categoriePrincipale: 'Pèlerinages religieux'
  }
];

// Simulated API delay (increased for more consistent loading experience)
const apiDelay = () => new Promise(resolve => setTimeout(resolve, 2000));

// Cache management with improved version tracking
let dataCache = {
  reservations: { data: null, timestamp: null, version: 1 },
  clients: { data: null, timestamp: null, version: 1 },
  packages: { data: null, timestamp: null, version: 1 },
  financial: { data: null, timestamp: null, version: 1 },
  counts: { data: null, timestamp: null, version: 1 },
  suppliers: { data: null, timestamp: null, version: 1 }, // Added suppliers cache
  calendarEvents: { data: null, timestamp: null, stats: null, version: 1 }, // Added calendar events cache
  documents: { data: null, timestamp: null, stats: null, version: 1 } // Added documents cache
};

// Global version tracking for real-time updates
let globalDataVersion = {
  reservations: 1,
  clients: 1,
  packages: 1,
  financial: 1,
  counts: 1,
  suppliers: 1,
  calendarEvents: 1,
  documents: 1,
  dashboard: 1
};

// Shared state for real-time data synchronization between components
let sharedAppState = {
  financial: {
    totalRevenue: 0,
    totalExpenses: 0,
    netProfit: 0,
    pendingPayments: 0,
    lastUpdated: Date.now()
  },
  reservations: {
    total: 0,
    confirmed: 0,
    pending: 0,
    cancelled: 0,
    lastUpdated: Date.now()
  },
  clients: {
    total: 0,
    premium: 0,
    standard: 0,
    bronze: 0,
    lastUpdated: Date.now()
  },
  dashboard: {
    lastUpdated: Date.now()
  }
};

  // Enhanced cache validation - checks both time and version
const isCacheValid = (cacheKey) => {
  // Dashboard data is never valid from cache - always refresh
  if (cacheKey === 'dashboard') {
    return false;
  }
  
  const cache = dataCache[cacheKey];
  // Reduced cache time to 5 seconds for more frequent updates
  const isTimeValid = cache && cache.timestamp && (Date.now() - cache.timestamp < 5000);
  const isVersionValid = cache && cache.version === globalDataVersion[cacheKey];
  
  // More aggressive cache invalidation
  return isTimeValid && isVersionValid && cache.data !== null;
};

// Function to update shared state for real-time data synchronization
const updateSharedState = (key, data) => {
  if (sharedAppState[key]) {
    console.log(`Updating shared state for ${key}`, data);
    sharedAppState[key] = {
      ...sharedAppState[key],
      ...data,
      lastUpdated: Date.now()
    };
    
    // Also update dashboard's last updated time to trigger refresh
    sharedAppState.dashboard.lastUpdated = Date.now();
    
    // Dispatch an event to notify components of shared state update
    window.dispatchEvent(new CustomEvent('sharedStateUpdate', {
      detail: {
        key,
        data: sharedAppState[key],
        timestamp: Date.now()
      }
    }));
  }
};

// Function to invalidate cache for a specific key
const invalidateCache = (cacheKey) => {
  if (dataCache[cacheKey]) {
    console.log(`Invalidating cache for ${cacheKey}`);
    // Increment global version to invalidate all related caches
    globalDataVersion[cacheKey]++;
    // Force dashboard refresh on any data change
    globalDataVersion.dashboard++;
    
    // Clear the cache entry completely to force a full refresh
    dataCache[cacheKey] = { data: null, timestamp: null, version: globalDataVersion[cacheKey] };
    
    // Always invalidate dashboard cache when any data changes
    if (cacheKey !== 'dashboard') {
      dataCache.dashboard = { data: null, timestamp: null, version: globalDataVersion.dashboard };
      
      // Force invalidate all related caches for complete refresh
      if (cacheKey === 'clients' || cacheKey === 'reservations') {
        dataCache.counts = { data: null, timestamp: null, version: globalDataVersion.counts++ };
      }
      
      if (cacheKey === 'financial' || cacheKey === 'reservations') {
        dataCache.financial = { data: null, timestamp: null, version: globalDataVersion.financial++ };
      }
    }
    
    // Dispatch event for real-time updates with more details
    window.dispatchEvent(new CustomEvent('dataVersionChange', {
      detail: { 
        key: cacheKey, 
        version: globalDataVersion[cacheKey],
        timestamp: Date.now(),
        affectedKeys: ['dashboard', 'all'] // Notify all components
      }
    }));
    
    // Also dispatch global refresh event for immediate propagation
    window.dispatchEvent(new CustomEvent('globalDataRefresh', {
      detail: {
        source: 'invalidateCache',
        key: cacheKey,
        timestamp: Date.now(),
        forceRefresh: true
      }
    }));
  }
};

/**
 * Fetch data from API with error handling
 * @param {string} endpoint - API endpoint to fetch data from
 * @param {Object} options - Fetch options
 * @returns {Promise<Object>} - Response data
 */
export const fetchData = async (endpoint, options = {}) => {
  try {
    const response = await fetch(`${config.apiUrl}/${endpoint}`, {
      method: options.method || 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      body: options.body ? JSON.stringify(options.body) : undefined,
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `Error ${response.status}: ${response.statusText}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error(`Error fetching data from ${endpoint}:`, error);
    // Return a standardized error response
    return {
      success: false,
      error: error.message || 'An error occurred while fetching data',
      data: []
    };
  }
};

/**
 * Create a new resource
 * @param {string} endpoint - API endpoint
 * @param {Object} data - Data to create
 * @returns {Promise<Object>} - Created resource
 */
export const createResource = async (endpoint, data) => {
  return fetchData(endpoint, {
    method: 'POST',
    body: data
  });
};

/**
 * Update an existing resource
 * @param {string} endpoint - API endpoint
 * @param {string} id - Resource ID
 * @param {Object} data - Data to update
 * @returns {Promise<Object>} - Updated resource
 */
export const updateResource = async (endpoint, id, data) => {
  return fetchData(`${endpoint}/${id}`, {
    method: 'PUT',
    body: data
  });
};

/**
 * Delete a resource
 * @param {string} endpoint - API endpoint
 * @param {string} id - Resource ID
 * @returns {Promise<Object>} - Response data
 */
export const deleteResource = async (endpoint, id) => {
  return fetchData(`${endpoint}/${id}`, {
    method: 'DELETE'
  });
};

/**
 * Fetch a single resource by ID
 * @param {string} endpoint - API endpoint
 * @param {string} id - Resource ID
 * @returns {Promise<Object>} - Resource data
 */
export const getResourceById = async (endpoint, id) => {
  return fetchData(`${endpoint}/${id}`);
};

/**
 * Helper function to handle file uploads
 * @param {string} endpoint - API endpoint
 * @param {FormData} formData - Form data with files
 * @returns {Promise<Object>} - Response data
 */
export const uploadFile = async (endpoint, formData) => {
  try {
    const response = await fetch(`${config.apiUrl}/${endpoint}`, {
      method: 'POST',
      body: formData, // Don't set Content-Type header, browser will set it with boundary
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `Error ${response.status}: ${response.statusText}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error(`Error uploading file to ${endpoint}:`, error);
    return {
      success: false,
      error: error.message || 'An error occurred while uploading file',
    };
  }
};

export const useReservationsData = (filters = {}) => {
  const [reservations, setReservations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [stats, setStats] = useState({
    total: 0,
    confirmed: 0,
    pending: 0,
    cancelled: 0
  });
  
  // Add force refresh support
  const { forceRefresh } = filters;

  const fetchReservationsData = async () => {
    console.log("Fetching reservations data...", forceRefresh ? "(forced)" : "");
    try {
      setLoading(true);
      
      // Check localStorage first
      const localReservations = localStorage.getItem('reservationsData');
      const localPackages = localStorage.getItem('packagesData');
      
      if (localReservations && localPackages) {
        console.log("Loading reservations from localStorage");
        
        const parsedReservations = JSON.parse(localReservations);
        const parsedPackages = JSON.parse(localPackages);
        
        console.log("Loaded reservations:", parsedReservations);
        
        // Process reservations to include package relationships
        const enhancedReservations = parsedReservations.map(res => {
          // Convert ID to number to ensure consistent comparison
          const forfaitId = Number(res.forfaitId);
          
          // Find related package
          const relatedPackage = parsedPackages.find(pkg => Number(pkg.id) === forfaitId);
          
          return {
            ...res,
            forfaitId, // Ensure forfaitId is a number
            clientId: Number(res.clientId),
            forfait: res.forfait || (relatedPackage ? relatedPackage.titre : 'Inconnu'),
            relatedPackage
          };
        });
        
        console.log("Enhanced reservations with package relationships:", enhancedReservations);
        
        // Apply filters
        let filteredReservations = [...enhancedReservations];
        
        if (filters.status) {
          filteredReservations = filteredReservations.filter(res => res.statut === filters.status);
        }
        
        if (filters.client) {
          filteredReservations = filteredReservations.filter(res => 
            res.clientId === filters.client || 
            res.clientNom === filters.client
          );
        }
        
        if (filters.destination) {
          filteredReservations = filteredReservations.filter(res => 
            res.destination.includes(filters.destination)
          );
        }
        
        if (filters.dateRange) {
          const [start, end] = filters.dateRange;
          filteredReservations = filteredReservations.filter(res => {
            const departDate = new Date(res.dateDepart);
            return departDate >= start && departDate <= end;
          });
        }
        
        setReservations(filteredReservations);
        
        // Calculate stats
        const confirmed = filteredReservations.filter(r => r.statut === 'Confirmée').length;
        const pending = filteredReservations.filter(r => r.statut === 'En attente').length;
        const cancelled = filteredReservations.filter(r => r.statut === 'Annulée').length;
        
        setStats({
          total: filteredReservations.length,
          confirmed,
          pending,
          cancelled
        });
        
        setLoading(false);
        return;
      } else {
        // If localStorage doesn't have data yet, initialize it with sample data
        console.log("Initializing reservations in localStorage with sample data");
        const initializedData = resetAndInitializeData();
        setReservations(initializedData.reservations);
        
        // Calculate stats
        const confirmed = initializedData.reservations.filter(r => r.statut === 'Confirmée').length;
        const pending = initializedData.reservations.filter(r => r.statut === 'En attente').length;
        const cancelled = initializedData.reservations.filter(r => r.statut === 'Annulée').length;
        
        setStats({
          total: initializedData.reservations.length,
          confirmed,
          pending,
          cancelled
        });
        
        setLoading(false);
        return;
      }
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReservationsData();
    
    // Listen for storage events
    const handleStorageChange = (e) => {
      if (e.key === 'reservationsData' || e.type === 'storage') {
        fetchReservationsData();
      }
    };
    
    // Listen for global data refresh events
    const handleGlobalDataRefresh = (e) => {
      console.log("Reservation data received global refresh event", e.detail);
      
      // Check if this is a cascade delete from client deletion
      if (e.detail && e.detail.cascadeDelete && e.detail.source === 'deleteClient') {
        console.log(`Reservations for client ${e.detail.clientId} were cascade deleted`);
      }
      
      fetchReservationsData();
    };
    
    // Listen for direct reservation data update events
    const handleReservationDataUpdate = (e) => {
      console.log("Reservation data update event received", e.detail);
      if (e.detail && e.detail.action === 'delete_multiple') {
        console.log(`${e.detail.count} reservations were deleted for client ${e.detail.clientId}`);
      }
      fetchReservationsData();
    };
    
    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('globalDataRefresh', handleGlobalDataRefresh);
    window.addEventListener('reservationDataUpdate', handleReservationDataUpdate);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('globalDataRefresh', handleGlobalDataRefresh);
      window.removeEventListener('reservationDataUpdate', handleReservationDataUpdate);
    };
  }, [filters.status, filters.client, filters.forfait, filters.dateRange, forceRefresh]);

  return { reservations, loading, error, stats };
};

// Global state for client data
let globalClientsData = [];
let clientDataListeners = [];

// Function to notify all listeners of client data changes
const notifyClientDataChange = () => {
  clientDataListeners.forEach(listener => listener());
};

// Direct client data manipulation functions
export const addClient = (newClient) => {
  console.log("Adding client directly:", newClient);
  
  // Get current data from localStorage
  const localData = localStorage.getItem('clientsData');
  console.log("Current localStorage data:", localData);
  
  let currentClients = [];
  
  if (localData) {
    try {
      currentClients = JSON.parse(localData);
      console.log("Parsed current clients:", currentClients.length);
    } catch (e) {
      console.error("Error parsing clients data:", e);
    }
  }
  
  // Add the new client
  const updatedClients = [...currentClients, newClient];
  console.log("Updated clients array:", updatedClients.length);
  
  // Update localStorage
  localStorage.setItem('clientsData', JSON.stringify(updatedClients));
  
  // Verify the data was saved
  const verifyData = localStorage.getItem('clientsData');
  console.log("Verification - localStorage after save:", verifyData);
  if (verifyData) {
    try {
      const parsedVerify = JSON.parse(verifyData);
      console.log("Verification - parsed clients count:", parsedVerify.length);
      console.log("Verification - new client in data:", parsedVerify.some(c => c.id === newClient.id));
    } catch (e) {
      console.error("Error parsing verification data:", e);
    }
  }
  
  // Update global state
  globalClientsData = updatedClients;
  
  // Notify listeners
  notifyClientDataChange();
  
  // Invalidate cache for clients
  invalidateCache('clients');
  
  // Update dataCache directly
  if (dataCache.clients) {
    dataCache.clients = {
      data: updatedClients,
      timestamp: Date.now(),
      version: globalDataVersion.clients
    };
  }
  
  // Force dashboard refresh
  invalidateCache('dashboard');
  
  // Also dispatch event for components that might be listening
  window.dispatchEvent(new CustomEvent('clientDataUpdate', { 
    detail: { type: 'clientsData', action: 'create', client: newClient } 
  }));
  
  // Dispatch dashboard update event
  window.dispatchEvent(new CustomEvent('dashboardUpdate', {
    detail: { 
      type: 'client_added', 
      source: 'addClient', 
      timestamp: Date.now(),
      forceRefresh: true
    }
  }));
  
  // Dispatch global data refresh event
  window.dispatchEvent(new CustomEvent('globalDataRefresh', {
    detail: {
      timestamp: Date.now(),
      source: 'addClient',
      affectedData: 'clients',
      forceRefresh: true
    }
  }));
  
  return newClient;
};

export const updateClient = (updatedClient) => {
  console.log("Updating client directly:", updatedClient);
  
  // Get current data from localStorage
  const localData = localStorage.getItem('clientsData');
  let currentClients = [];
  
  if (localData) {
    try {
      currentClients = JSON.parse(localData);
    } catch (e) {
      console.error("Error parsing clients data:", e);
    }
  }
  
  // Update the client
  const updatedClients = currentClients.map(client => 
    client.id === updatedClient.id ? updatedClient : client
  );
  
  // Update localStorage
  localStorage.setItem('clientsData', JSON.stringify(updatedClients));
  
  // Update global state
  globalClientsData = updatedClients;
  
  // Notify listeners
  notifyClientDataChange();
  
  // Invalidate cache for clients
  invalidateCache('clients');
  
  // Update dataCache directly
  if (dataCache.clients) {
    dataCache.clients = {
      data: updatedClients,
      timestamp: Date.now(),
      version: globalDataVersion.clients
    };
  }
  
  // Also dispatch event for components that might be listening
  window.dispatchEvent(new CustomEvent('clientDataUpdate', { 
    detail: { type: 'clientsData', action: 'update', client: updatedClient } 
  }));
  
  // Dispatch global data refresh event
  window.dispatchEvent(new CustomEvent('globalDataRefresh', {
    detail: {
      timestamp: Date.now(),
      source: 'updateClient',
      affectedData: 'clients'
    }
  }));
  
  return updatedClient;
};

// Function to delete reservations for a specific client
const deleteReservationsForClient = (clientId) => {
  console.log(`Deleting all reservations for client ${clientId}`);
  
  // Normalize client ID
  const normalizedClientId = clientId !== undefined && clientId !== null ? Number(clientId) : null;
  
  // Get current reservations data from localStorage
  const localReservationsData = localStorage.getItem('reservationsData');
  let currentReservations = [];
  
  if (localReservationsData) {
    try {
      currentReservations = JSON.parse(localReservationsData);
      console.log(`Found ${currentReservations.length} reservations, checking for client ${clientId}`);
    } catch (e) {
      console.error("Error parsing reservations data:", e);
      return false;
    }
  } else {
    console.log("No reservations data found in localStorage");
    return false;
  }
  
  // Helper function to normalize ID for comparison
  const normalizeId = (id) => id !== undefined && id !== null ? Number(id) : null;
  
  // Find reservations belonging to this client
  const clientReservations = currentReservations.filter(res => 
    normalizeId(res.clientId) === normalizedClientId
  );
  
  if (clientReservations.length === 0) {
    console.log(`No reservations found for client ${clientId}`);
    return false;
  }
  
  console.log(`Found ${clientReservations.length} reservations for client ${clientId}, deleting...`);
  
  // Remove reservations for this client
  const updatedReservations = currentReservations.filter(res => 
    normalizeId(res.clientId) !== normalizedClientId
  );
  
  // Update localStorage
  localStorage.setItem('reservationsData', JSON.stringify(updatedReservations));
  
  // Invalidate reservations cache
  invalidateCache('reservations');
  
  // Also delete any related financial transactions
  deleteFinancialTransactionsForClient(clientId);
  
  // Dispatch event for reservation data update
  window.dispatchEvent(new CustomEvent('reservationDataUpdate', { 
    detail: { 
      type: 'reservationsData', 
      action: 'delete_multiple', 
      clientId: clientId,
      count: clientReservations.length
    } 
  }));
  
  return true;
};

// Function to delete financial transactions related to a client
const deleteFinancialTransactionsForClient = (clientId) => {
  console.log(`Deleting financial transactions for client ${clientId}`);
  
  // Normalize client ID
  const normalizedClientId = clientId !== undefined && clientId !== null ? Number(clientId) : null;
  
  // Get current transactions data from localStorage
  const localTransactionsData = localStorage.getItem('transactionsData');
  let currentTransactions = [];
  
  if (localTransactionsData) {
    try {
      currentTransactions = JSON.parse(localTransactionsData);
    } catch (e) {
      console.error("Error parsing transactions data:", e);
      return false;
    }
  } else {
    return false;
  }
  
  // Helper function to normalize ID for comparison
  const normalizeId = (id) => id !== undefined && id !== null ? Number(id) : null;
  
  // Remove transactions for this client
  const updatedTransactions = currentTransactions.filter(txn => 
    normalizeId(txn.clientId) !== normalizedClientId
  );
  
  // Update localStorage
  localStorage.setItem('transactionsData', JSON.stringify(updatedTransactions));
  
  // Invalidate financial cache
  invalidateCache('financial');
  
  return true;
};

export const deleteClient = (clientId) => {
  console.log("Deleting client directly:", clientId);
  
  // Normalize client ID
  const normalizedClientId = clientId !== undefined && clientId !== null ? Number(clientId) : null;
  
  // Get current data from localStorage
  const localData = localStorage.getItem('clientsData');
  let currentClients = [];
  
  if (localData) {
    try {
      currentClients = JSON.parse(localData);
    } catch (e) {
      console.error("Error parsing clients data:", e);
    }
  }
  
  // Helper function to normalize ID for comparison
  const normalizeId = (id) => id !== undefined && id !== null ? Number(id) : null;
  
  // Delete the client
  const updatedClients = currentClients.filter(client => normalizeId(client.id) !== normalizedClientId);
  
  // Update localStorage
  localStorage.setItem('clientsData', JSON.stringify(updatedClients));
  
  // Update global state
  globalClientsData = updatedClients;
  
  // Notify listeners
  notifyClientDataChange();
  
  // Invalidate cache for clients
  invalidateCache('clients');
  
  // Update dataCache directly
  if (dataCache.clients) {
    dataCache.clients = {
      data: updatedClients,
      timestamp: Date.now(),
      version: globalDataVersion.clients
    };
  }
  
  // Delete all reservations for this client (cascade delete)
  const reservationsDeleted = deleteReservationsForClient(clientId);
  console.log(`Cascade delete of reservations ${reservationsDeleted ? 'successful' : 'not needed'}`);
  
  // Also dispatch event for components that might be listening
  window.dispatchEvent(new CustomEvent('clientDataUpdate', { 
    detail: { 
      type: 'clientsData', 
      action: 'delete', 
      id: clientId,
      cascadeDelete: reservationsDeleted
    } 
  }));
  
  // Dispatch global data refresh event with cascade info
  window.dispatchEvent(new CustomEvent('globalDataRefresh', {
    detail: {
      timestamp: Date.now(),
      source: 'deleteClient',
      affectedData: ['clients', 'reservations', 'financial'],
      cascadeDelete: reservationsDeleted,
      clientId: clientId
    }
  }));
  
  // Update shared state
  updateSharedState('clients', { lastDeleted: clientId, lastUpdated: Date.now() });
  
  return clientId;
};

export const useClientsData = (options = {}) => {
  // Add force refresh support
  const { forceRefresh } = options;
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [stats, setStats] = useState({
    total: 0,
    premium: 0,
    standard: 0,
    bronze: 0
  });
  
  const fetchClientData = useCallback(async () => {
    try {
      setLoading(true);
      console.log("Fetching client data...", forceRefresh ? "(forced)" : "");
      
      // Check if we have clients in localStorage first
      const localClients = localStorage.getItem('clientsData');
      if (localClients) {
        const parsedClients = JSON.parse(localClients);
        console.log("Loaded clients from localStorage:", parsedClients.length);
        
        // Update global state
        globalClientsData = parsedClients;
        
        setClients(parsedClients);
        
        // Calculate stats
        const premium = parsedClients.filter(c => c.niveauFidelite === 'Premium').length;
        const standard = parsedClients.filter(c => c.niveauFidelite === 'Standard').length;
        const bronze = parsedClients.filter(c => c.niveauFidelite === 'Bronze').length;
        
        setStats({
          total: parsedClients.length,
          premium,
          standard,
          bronze
        });
        
        setLoading(false);
        return;
      }
      
      // Use cache if valid
      if (isCacheValid('clients')) {
        const clientsData = dataCache.clients.data;
        setClients(clientsData);
        
        // Cache to localStorage for future use
        localStorage.setItem('clientsData', JSON.stringify(clientsData));
        
        // Calculate stats
        const premium = clientsData.filter(c => c.niveauFidelite === 'Premium').length;
        const standard = clientsData.filter(c => c.niveauFidelite === 'Standard').length;
        const bronze = clientsData.filter(c => c.niveauFidelite === 'Bronze').length;
        
        setStats({
          total: clientsData.length,
          premium,
          standard,
          bronze
        });
        
        setLoading(false);
        return;
      }
      
      // Fetch from API
      try {
        const response = await fetch('/api/clients');
        if (!response.ok) throw new Error('Erreur serveur');
        const data = await response.json();
        
        // Update with real data
        setClients(data.data || []);
        
                  // Cache the data with version tracking
        dataCache.clients = {
          data: data.data || [],
            timestamp: Date.now(),
            version: globalDataVersion.clients
        };
        
        // Store in localStorage
        localStorage.setItem('clientsData', JSON.stringify(data.data || []));
        
        // Calculate stats from real data if available
        if (data.data && data.data.length > 0) {
          const premium = data.data.filter(c => c.niveauFidelite === 'Premium').length;
          const standard = data.data.filter(c => c.niveauFidelite === 'Standard').length;
          const bronze = data.data.filter(c => c.niveauFidelite === 'Bronze').length;
          
          setStats({
            total: data.data.length,
            premium,
            standard,
            bronze
          });
        }
        
      } catch (error) {
        console.error("API error:", error);
        
        // Fallback to sample data
        await apiDelay();
        setClients(sampleClients);
        
              // Cache the data with version tracking
        dataCache.clients = {
          data: sampleClients,
          timestamp: Date.now(),
          version: globalDataVersion.clients
        };
        
        // Store in localStorage
        localStorage.setItem('clientsData', JSON.stringify(sampleClients));
        
        // Calculate stats
        const premium = sampleClients.filter(c => c.niveauFidelite === 'Premium').length;
        const standard = sampleClients.filter(c => c.niveauFidelite === 'Standard').length;
        const bronze = sampleClients.filter(c => c.niveauFidelite === 'Bronze').length;
        
        setStats({
          total: sampleClients.length,
          premium,
          standard,
          bronze
        });
      }
      
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  }, [forceRefresh]);

  useEffect(() => {
    fetchClientData();
    
    // Register with global listener system
    const listener = () => {
      console.log("Client data listener triggered");
      setClients([...globalClientsData]);
      
      // Update stats
      const premium = globalClientsData.filter(c => c.niveauFidelite === 'Premium').length;
      const standard = globalClientsData.filter(c => c.niveauFidelite === 'Standard').length;
      const bronze = globalClientsData.filter(c => c.niveauFidelite === 'Bronze').length;
      
      setStats({
        total: globalClientsData.length,
        premium,
        standard,
        bronze
      });
    };
    
    clientDataListeners.push(listener);
    
    // Listen for storage events
    const handleStorageChange = (e) => {
      console.log("Storage event received in useClientsData:", e);
      if (e.key === 'clientsData' || e.type === 'storage' || 
          (e.detail && e.detail.type === 'clientsData')) {
        console.log("Refreshing client data due to storage event");
        fetchClientData();
      }
    };
    
    // Listen for custom client data update events
    const handleClientDataUpdate = (e) => {
      console.log("Client data update event received:", e);
      fetchClientData();
    };
    
    // Listen for global data refresh events
    const handleGlobalDataRefresh = (e) => {
      console.log("Client data received global refresh event", e.detail);
      if (!e.detail || e.detail.affectedData === 'clients' || e.detail.affectedData === 'all') {
        fetchClientData();
      }
    };
    
    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('clientDataUpdate', handleClientDataUpdate);
    window.addEventListener('globalDataRefresh', handleGlobalDataRefresh);
    
    return () => {
      // Remove from global listeners
      const index = clientDataListeners.indexOf(listener);
      if (index > -1) {
        clientDataListeners.splice(index, 1);
      }
      
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('clientDataUpdate', handleClientDataUpdate);
      window.removeEventListener('globalDataRefresh', handleGlobalDataRefresh);
    };
  }, [fetchClientData]);

  return { clients, loading, error, stats };
};

export const usePackagesData = (filters = {}) => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [stats, setStats] = useState({
    total: 0,
    active: 0,
    categories: {}
  });

  const fetchPackagesData = async () => {
    try {
      setLoading(true);
      
      // Check if we have packages in localStorage first
      const localPackages = localStorage.getItem('packagesData');
      const localReservations = localStorage.getItem('reservationsData');
      const localClients = localStorage.getItem('clientsData');
      
      if (localPackages && localReservations && localClients) {
        console.log("Loading packages data from localStorage");
        
        const parsedPackages = JSON.parse(localPackages);
        const parsedReservations = JSON.parse(localReservations);
        const parsedClients = JSON.parse(localClients);
        
        console.log("Loaded packages:", parsedPackages);
        
        // Process packages to ensure they have client and reservation relationships
        const enhancedPackages = parsedPackages.map(pkg => {
          // Ensure ID is a number for comparison
          const packageId = Number(pkg.id);
          
          // Find related reservations if not already included
          const relatedReservations = pkg.reservations || parsedReservations.filter(res => 
            Number(res.forfaitId) === packageId
          );
          
          // Find related clients if not already included
          const relatedClients = pkg.clients || parsedClients.filter(client =>
            relatedReservations.some(res => Number(res.clientId) === Number(client.id))
          );
          
          return {
            ...pkg,
            id: packageId,
            reservations: relatedReservations,
            reservationCount: relatedReservations.length,
            clients: relatedClients,
            clientCount: relatedClients.length,
            clientsInteresses: relatedClients // Add clientsInteresses for UI compatibility
          };
        });
        
        console.log("Enhanced packages with complete relationships:", enhancedPackages);
        
        // Apply filters if provided
        let filteredPackages = [...enhancedPackages];
        
        if (filters.category) {
          filteredPackages = filteredPackages.filter(pkg => pkg.categorie === filters.category);
        }
        
        setPackages(filteredPackages);
        
        // Calculate stats
        const active = filteredPackages.filter(p => p.statut === 'Actif').length;
        const categories = {};
        filteredPackages.forEach(pkg => {
          if (!categories[pkg.categorie]) {
            categories[pkg.categorie] = 0;
          }
          categories[pkg.categorie]++;
        });
        
        setStats({
          total: filteredPackages.length,
          active,
          categories
        });
        
        setLoading(false);
        return;
      } else {
        // If localStorage doesn't have data yet, initialize it with sample data
        console.log("Initializing packages in localStorage with sample data");
        const initializedData = resetAndInitializeData();
        setPackages(initializedData.packages);
        
        // Calculate stats
        const active = initializedData.packages.filter(p => p.statut === 'Actif').length;
        const categories = {};
        initializedData.packages.forEach(pkg => {
          if (!categories[pkg.categorie]) {
            categories[pkg.categorie] = 0;
          }
          categories[pkg.categorie]++;
        });
        
        setStats({
          total: initializedData.packages.length,
          active,
          categories
        });
        
        setLoading(false);
        return;
      }
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPackagesData();
    
    // Listen for storage events
    const handleStorageChange = (e) => {
      if (e.key === 'packagesData' || e.type === 'storage') {
        fetchPackagesData();
      }
    };
    
    window.addEventListener('storage', handleStorageChange);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [filters.category]);

  return { packages, loading, error, stats };
};

export const useFinancialData = (options = {}) => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [stats, setStats] = useState({
    totalRevenue: 0,
    totalExpenses: 0,
    netProfit: 0,
    pendingPayments: 0,
    recentTransactions: []
  });

  // For tracking updates from finances page
  const [updateCounter, setUpdateCounter] = useState(0);
  
  // Add force refresh support
  const { forceRefresh } = options;

  // Get related data for interconnection
  const { reservations, loading: reservationsLoading } = useReservationsData();
  const { packages, loading: packagesLoading } = usePackagesData();
  // Use the base suppliers hook to avoid circular dependency
  const { suppliers, loading: suppliersLoading } = useBaseSuppliersData();

  // Enhanced listener for all data changes that affect financial data
  useEffect(() => {
    const handleFinancialUpdate = (e) => {
      console.log("Financial data update event received:", e.detail);
      setUpdateCounter(prev => prev + 1);
    };
    
    const handleDashboardUpdate = (e) => {
      console.log("Dashboard update event received:", e.detail);
      setUpdateCounter(prev => prev + 1);
    };
    
    const handleDataVersionChange = (e) => {
      // Only update if the change is relevant to financial data
      if (e.detail && ['financial', 'reservations', 'clients', 'packages', 'suppliers'].includes(e.detail.key)) {
        console.log("Data version change affecting financial data:", e.detail);
        setUpdateCounter(prev => prev + 1);
      }
    };
    
    // Handle global data refresh events including cascade deletes
    const handleGlobalDataRefresh = (e) => {
      console.log("Financial data received global refresh event", e.detail);
      
      // Check if this is a cascade delete from client deletion that affects financial data
      if (e.detail && e.detail.cascadeDelete && e.detail.source === 'deleteClient' && 
          (e.detail.affectedData.includes('financial') || e.detail.affectedData.includes('all'))) {
        console.log(`Financial transactions for client ${e.detail.clientId} were cascade deleted`);
      }
      
      setUpdateCounter(prev => prev + 1);
    };
    
    // Listen for storage changes
    const handleStorageChange = (e) => {
      if (e.key === 'transactionsData' || e.key === 'financialData' || e.type === 'storage') {
        console.log("Financial data storage change detected");
        setUpdateCounter(prev => prev + 1);
      }
    };
    
    window.addEventListener('financialDataUpdate', handleFinancialUpdate);
    window.addEventListener('dashboardUpdate', handleDashboardUpdate);
    window.addEventListener('dataVersionChange', handleDataVersionChange);
    window.addEventListener('globalDataRefresh', handleGlobalDataRefresh);
    window.addEventListener('storage', handleStorageChange);
    
    return () => {
      window.removeEventListener('financialDataUpdate', handleFinancialUpdate);
      window.removeEventListener('dashboardUpdate', handleDashboardUpdate);
      window.removeEventListener('dataVersionChange', handleDataVersionChange);
      window.removeEventListener('globalDataRefresh', handleGlobalDataRefresh);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        
        // Check if we have transactions in localStorage
        const localTransactions = localStorage.getItem('transactionsData');
        console.log("Financial data from localStorage:", localTransactions);
        
        if (localTransactions) {
          // Get all transactions for accurate stats
          let parsedTransactions = [];
          try {
            parsedTransactions = JSON.parse(localTransactions);
            console.log("Parsed transactions:", parsedTransactions);
          } catch (e) {
            console.error("Error parsing transactions:", e);
          }
          
          // Sort by date (newest first)
          parsedTransactions = parsedTransactions
            .sort((a, b) => new Date(b.date) - new Date(a.date));
          
          // Save back to localStorage
          localStorage.setItem('transactionsData', JSON.stringify(parsedTransactions));
          
          setTransactions(parsedTransactions);
          
          // Calculate stats - ensure proper number conversion for montant
          const totalRevenue = parsedTransactions
            .filter(t => t.type === 'Recette')
            .reduce((sum, t) => {
              const amount = typeof t.montant === 'string' ? parseFloat(t.montant) : (t.montant || 0);
              return sum + amount;
            }, 0);
            
          console.log("Calculated total revenue:", totalRevenue);
            
          const totalExpenses = parsedTransactions
            .filter(t => t.type === 'Dépense')
            .reduce((sum, t) => {
              const amount = typeof t.montant === 'string' ? parseFloat(t.montant) : (t.montant || 0);
              return sum + amount;
            }, 0);
            
          const netProfit = totalRevenue - totalExpenses;
          
          const pendingPayments = parsedTransactions
            .filter(t => t.statut === 'En attente')
            .reduce((sum, t) => {
              const amount = typeof t.montant === 'string' ? parseFloat(t.montant) : (t.montant || 0);
              return sum + amount;
            }, 0);
            
          const recentTransactions = parsedTransactions
            .slice(0, 5);
          
          // Create stats object
          const statsObject = {
            totalRevenue,
            totalExpenses,
            netProfit,
            pendingPayments,
            recentTransactions
          };
          
          // Update shared app state for real-time access by dashboard and other components
          updateSharedState('financial', {
            totalRevenue,
            totalExpenses,
            netProfit,
            pendingPayments
          });
          
          // Update component state
          setStats(statsObject);
          
          setLoading(false);
          return;
        }
        
        // Use cache if valid
        if (isCacheValid('financial')) {
          let financialData = dataCache.financial.data;
          
          // Sort transactions but keep all for accurate stats
          financialData = financialData
            .sort((a, b) => new Date(b.date) - new Date(a.date));
            
          setTransactions(financialData);
          
          // Calculate stats
          const totalRevenue = financialData
            .filter(t => t.type === 'Recette')
            .reduce((sum, t) => sum + (t.montant || 0), 0);
            
          const totalExpenses = financialData
            .filter(t => t.type === 'Dépense')
            .reduce((sum, t) => sum + (t.montant || 0), 0);
            
          const netProfit = totalRevenue - totalExpenses;
          
          const pendingPayments = financialData
            .filter(t => t.statut === 'En attente')
            .reduce((sum, t) => sum + (t.montant || 0), 0);
            
          const recentTransactions = financialData
            .slice(0, 5);
          
          setStats({
            totalRevenue,
            totalExpenses,
            netProfit,
            pendingPayments,
            recentTransactions
          });
          
          setLoading(false);
          return;
        }
        
        // Wait for related data to load
        if (reservationsLoading || packagesLoading || suppliersLoading) {
          return;
        }
        
        // Fetch from API
        try {
          const response = await fetch('/api/finances/transactions');
          if (!response.ok) throw new Error('Erreur serveur');
          const data = await response.json();
          
          // Update with real data
          setTransactions(data.data || []);
          
                  // Cache the data with version tracking
          dataCache.financial = {
            data: data.data || [],
            timestamp: Date.now(),
            version: globalDataVersion.financial
          };
          
          // Calculate stats from real data
          const totalRevenue = data.data
            .filter(t => t.type === 'Recette')
            .reduce((sum, t) => sum + (t.montant || 0), 0);
            
          const totalExpenses = data.data
            .filter(t => t.type === 'Dépense')
            .reduce((sum, t) => sum + (t.montant || 0), 0);
            
          const netProfit = totalRevenue - totalExpenses;
          
          const pendingPayments = data.data
            .filter(t => t.statut === 'En attente')
            .reduce((sum, t) => sum + (t.montant || 0), 0);
            
          const recentTransactions = data.data
            .sort((a, b) => new Date(b.date) - new Date(a.date))
            .slice(0, 5);
          
          setStats({
            totalRevenue,
            totalExpenses,
            netProfit,
            pendingPayments,
            recentTransactions
          });
          
        } catch (error) {
          console.error("API error:", error);
          
          // Fallback to generated data based on reservations, packages, and suppliers
          await apiDelay();
          
          // Generate comprehensive financial data
          const financialData = generateFinancialData(reservations, packages, suppliers);
          
          setTransactions(financialData);
          
                  // Cache the data with version tracking
          dataCache.financial = {
            data: financialData,
            timestamp: Date.now(),
            version: globalDataVersion.financial
          };
          
          // Calculate stats
          const totalRevenue = financialData
            .filter(t => t.type === 'Recette')
            .reduce((sum, t) => sum + (t.montant || 0), 0);
            
          const totalExpenses = financialData
            .filter(t => t.type === 'Dépense')
            .reduce((sum, t) => sum + (t.montant || 0), 0);
            
          const netProfit = totalRevenue - totalExpenses;
          
          const pendingPayments = financialData
            .filter(t => t.statut === 'En attente')
            .reduce((sum, t) => sum + (t.montant || 0), 0);
            
          const recentTransactions = financialData
            .sort((a, b) => new Date(b.date) - new Date(a.date))
            .slice(0, 5);
          
          setStats({
            totalRevenue,
            totalExpenses,
            netProfit,
            pendingPayments,
            recentTransactions
          });
        }
        
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchData();
  }, [reservations, packages, suppliers, reservationsLoading, packagesLoading, suppliersLoading, updateCounter, forceRefresh]);

  return { transactions, loading, error, stats };
};

/**
 * Generate comprehensive financial data based on reservations, packages, and suppliers
 */
const generateFinancialData = (reservations, packages, suppliers) => {
  const transactions = [];
  
  // 1. Generate revenue transactions from reservations
  const revenueTransactions = reservations.map(reservation => {
    const package_ = packages.find(p => p.id === reservation.forfaitId);
    const commissionRate = 0.1; // 10% commission rate
    const commission = reservation.prixTotal * commissionRate;
    
    return {
      id: `TR-REC-${reservation.id.substring(3)}`,
      type: 'Recette',
      categorie: 'Réservation',
      reservationId: reservation.id,
      clientId: reservation.clientId,
      clientNom: reservation.clientNom,
      forfaitId: reservation.forfaitId,
      forfaitNom: reservation.forfait,
      montant: reservation.prixTotal,
      montantHT: Math.round(reservation.prixTotal / 1.19), // Assuming 19% tax
      taxes: Math.round(reservation.prixTotal * 0.19),
      commission: commission,
      methode: Math.random() > 0.5 ? 'Carte bancaire' : 'Virement',
      date: reservation.dateReservation,
      statut: reservation.statutPaiement === 'En attente' ? 'En attente' : 'Confirmé',
      notes: `Réservation ${package_?.titre || reservation.forfait}`,
      reference: `REF-${new Date(reservation.dateReservation).getFullYear()}-${reservation.id.substring(3)}`
    };
  });
  
  // 2. Generate expense transactions for each supplier
  const expenseTransactions = [];
  
  suppliers.forEach(supplier => {
    // Find packages associated with this supplier
    const supplierPackages = packages.filter(p => 
      p.destination?.includes(supplier.ville) || 
      p.destination?.includes(supplier.pays)
    );
    
    // Find reservations related to this supplier's packages
    const supplierReservations = reservations.filter(r => 
      supplierPackages.some(p => p.id === r.forfaitId)
    );
    
    // Generate expense transactions based on supplier type
    if (supplier.type === 'Hôtel' || supplier.type === 'Transport') {
      supplierReservations.forEach((reservation, index) => {
        // Calculate supplier cost (60-80% of package price)
        const package_ = packages.find(p => p.id === reservation.forfaitId);
        const supplierCostRate = supplier.type === 'Hôtel' ? 0.6 : 0.7;
        const supplierCost = Math.round(reservation.prixTotal * supplierCostRate);
        
        expenseTransactions.push({
          id: `TR-DEP-${supplier.id}-${index}`,
          type: 'Dépense',
          categorie: supplier.type,
          reservationId: reservation.id,
          fournisseurId: supplier.id,
          fournisseurNom: supplier.nom,
          montant: supplierCost,
          montantHT: Math.round(supplierCost / 1.19),
          taxes: Math.round(supplierCost * 0.19),
          methode: 'Virement',
          date: new Date(new Date(reservation.dateReservation).getTime() + 86400000 * 3).toISOString().split('T')[0], // 3 days after reservation
          statut: Math.random() > 0.2 ? 'Confirmé' : 'En attente',
          notes: `Paiement ${supplier.type} pour réservation ${reservation.id}`,
          reference: `DEP-${supplier.id.substring(0, 3)}-${new Date().getFullYear()}-${index + 100}`
        });
      });
    } else {
      // General supplier expenses (marketing, services, etc.)
      const supplierCost = Math.round(5000 + Math.random() * 20000);
      
      expenseTransactions.push({
        id: `TR-DEP-${supplier.id}`,
        type: 'Dépense',
        categorie: supplier.type,
        fournisseurId: supplier.id,
        fournisseurNom: supplier.nom,
        montant: supplierCost,
        montantHT: Math.round(supplierCost / 1.19),
        taxes: Math.round(supplierCost * 0.19),
        methode: 'Virement',
        date: new Date(Date.now() - Math.random() * 30 * 86400000).toISOString().split('T')[0], // Random date in last 30 days
        statut: Math.random() > 0.2 ? 'Confirmé' : 'En attente',
        notes: `Services ${supplier.type}`,
        reference: `DEP-FOU-${new Date().getFullYear()}-${supplier.id.substring(0, 3)}`
      });
    }
  });
  
  // Combine all transactions
  transactions.push(...revenueTransactions);
  transactions.push(...expenseTransactions);
  
  // Sort by date (newest first) and limit to 5 transactions
  return transactions
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(0, 5);
};

// Reports data
export const useReservationsReportData = (period = 'month', destination = 'all') => {
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // Use our reservations data hook with the filters
  const { reservations, loading: reservationsLoading, stats: reservationsStats } = useReservationsData({
    period,
    destination
  });
  const { clients, loading: clientsLoading } = useClientsData();
  const { packages, loading: packagesLoading } = usePackagesData();
  const { transactions, loading: financialLoading } = useFinancialData();
  
  useEffect(() => {
    const generateReport = async () => {
      try {
        // Make sure we have data before proceeding
        if (reservationsLoading || clientsLoading || packagesLoading || financialLoading) {
          setLoading(true);
          return;
        }
        
        setLoading(true);
        
        // Check if we have the required data
        if (!reservations || !clients || !packages || !transactions) {
          throw new Error("Données manquantes pour générer le rapport");
        }
        
        // Count reservations by status - use stats if available, otherwise calculate
        const confirmed = reservationsStats?.confirmed || reservations.filter(r => r.statut === 'Confirmée').length;
        const pending = reservationsStats?.pending || reservations.filter(r => r.statut === 'En attente').length;
        const cancelled = reservationsStats?.cancelled || reservations.filter(r => r.statut === 'Annulée').length;
        const total = reservationsStats?.total || reservations.length;
        
        // Calculate financial metrics
        const revenue = reservationsStats?.revenue || reservations.reduce((sum, r) => sum + r.prixTotal, 0);
        const averageValue = total > 0 ? revenue / total : 0;
        
        // Conversion rate (confirmed/total)
        const conversionRate = total > 0 ? (confirmed / total) * 100 : 0;
        
        // Cancellation rate
        const cancelationRate = total > 0 ? (cancelled / total) * 100 : 0;
        
        // Calculate repeat customers
        const clientReservationCounts = new Map();
        reservations.forEach(reservation => {
          const clientId = reservation.clientId;
          clientReservationCounts.set(clientId, (clientReservationCounts.get(clientId) || 0) + 1);
        });
        
        const repeatClients = Array.from(clientReservationCounts.values()).filter(count => count > 1).length;
        const repeatCustomerRate = clientReservationCounts.size > 0 ? (repeatClients / clientReservationCounts.size) * 100 : 0;
        
        // Prepare destinations data
        const destinationsMap = new Map();
        reservations.forEach(reservation => {
          const dest = reservation.destination;
          if (!destinationsMap.has(dest)) {
            destinationsMap.set(dest, {
              name: dest,
              bookings: 0,
              revenue: 0,
              satisfaction: 0,
              satisfactionCount: 0,
              clients: new Set(),
              totalValue: 0,
              canceledBookings: 0
            });
          }
          
          const destData = destinationsMap.get(dest);
          destData.bookings++;
          destData.revenue += reservation.prixTotal;
          destData.clients.add(reservation.clientId);
          destData.totalValue += reservation.prixTotal;
          
          if (reservation.statut === 'Annulée') {
            destData.canceledBookings++;
          }
        });
        
        // Calculate averages and add color
        const colors = ['#1e40af', '#059669', '#7c3aed', '#f59e0b', '#dc2626', '#6366f1', '#ec4899', '#64748b'];
        const destinationsData = Array.from(destinationsMap.values()).map((dest, index) => {
          // Find the package corresponding to this destination
          const packagesForDest = packages.filter(p => p.destination === dest.name);
          
          // Calculate seasonality based on bookings per month
          const destinationReservations = reservations.filter(r => r.destination === dest.name);
          const monthCounts = Array(12).fill(0);
          destinationReservations.forEach(res => {
            const month = new Date(res.dateReservation).getMonth();
            monthCounts[month]++;
          });
          
          // Determine peak and low seasons
          const maxBookings = Math.max(...monthCounts);
          const minBookings = Math.min(...monthCounts);
          const peakMonths = monthCounts.map((count, idx) => count >= maxBookings * 0.8 ? idx : -1).filter(idx => idx !== -1);
          const lowMonths = monthCounts.map((count, idx) => count <= minBookings * 1.2 ? idx : -1).filter(idx => idx !== -1);
          
          // Convert month numbers to names
          const monthNames = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
          const peakSeasonText = peakMonths.length > 0 
            ? `Haute saison: ${peakMonths.map(m => monthNames[m]).join(', ')}` 
            : 'Haute saison: Mai-Septembre';
          
          // Calculate client profile based on actual client data
          const clientIds = Array.from(dest.clients);
          const destClients = clients.filter(c => clientIds.includes(c.id));
          
          // Count client preferences
          const preferences = destClients.flatMap(c => c.preferencesVoyage || []);
          const preferenceCounts = preferences.reduce((acc, pref) => {
            acc[pref] = (acc[pref] || 0) + 1;
            return acc;
          }, {});
          
          // Get top 2 preferences
          const topPreferences = Object.entries(preferenceCounts)
            .sort((a, b) => b[1] - a[1])
            .slice(0, 2)
            .map(([pref]) => pref);
          
          // Calculate satisfaction based on a combination of cancellation rate and repeat bookings
          const cancelRate = dest.bookings > 0 ? (dest.canceledBookings / dest.bookings) * 100 : 0;
          const repeatRateForDest = clientIds.length > 0 ? 
            (clientIds.filter(id => clientReservationCounts.get(id) > 1).length / clientIds.length) * 100 : 0;
          
          // Calculate satisfaction score (between 3.5 and 5.0)
          const baseSatisfaction = 3.5;
          const satisfactionBonus = Math.min(1.5, (1 - cancelRate / 100) + (repeatRateForDest / 100));
          const satisfaction = parseFloat((baseSatisfaction + satisfactionBonus).toFixed(1));
          
          return {
            name: dest.name,
            bookings: dest.bookings,
            revenue: dest.revenue,
            avgPrice: dest.bookings > 0 ? Math.round(dest.revenue / dest.bookings) : 0,
            satisfaction: satisfaction,
            repeatRate: Math.round(repeatRateForDest),
            cancelRate: Math.round(cancelRate),
            seasonality: peakSeasonText,
            topServices: packagesForDest.length > 0 ? 
              packagesForDest[0].inclusions.slice(0, 3) : 
              ['Visites guidées', 'Transferts', 'Hébergement'],
            clientProfile: topPreferences.length > 0 ? 
              `${topPreferences.join(', ')}, ${Math.floor(25 + Math.random() * 20)}-${Math.floor(45 + Math.random() * 20)} ans` : 
              'Familles et couples, 25-45 ans',
            growth: Math.round(10 + (index * 5) % 25),
            color: colors[index % colors.length]
          };
        });
        
        // Generate monthly reservation chart data based on actual bookings
        const monthlyBookings = Array(12).fill(0);
        reservations.forEach(res => {
          const month = new Date(res.dateReservation).getMonth();
          monthlyBookings[month]++;
        });
        
        const monthNames = ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sept', 'Oct', 'Nov', 'Déc'];
        const chartData = monthNames.map((name, idx) => ({
          name,
          value: monthlyBookings[idx]
        }));

        // Calculate seasonal trends
        const maxMonthIndex = monthlyBookings.indexOf(Math.max(...monthlyBookings));
        const minMonthIndex = monthlyBookings.indexOf(Math.min(...monthlyBookings));
        
        const peakSeason = `${monthNames[maxMonthIndex]}-${monthNames[(maxMonthIndex + 2) % 12]}`;
        const lowSeason = `${monthNames[minMonthIndex]}-${monthNames[(minMonthIndex + 2) % 12]}`;
        
        // Calculate growth rate by comparing first half with second half of the data
        const firstHalf = monthlyBookings.slice(0, 6).reduce((sum, val) => sum + val, 0);
        const secondHalf = monthlyBookings.slice(6).reduce((sum, val) => sum + val, 0);
        const growth = firstHalf > 0 ? ((secondHalf - firstHalf) / firstHalf) * 100 : 0;
        
        const reportData = {
          total,
          confirmed,
          pending,
          cancelled,
          revenue,
          averageValue,
          conversionRate,
          cancelationRate,
          repeatCustomers: repeatCustomerRate,
          seasonalTrends: {
            peak: peakSeason,
            low: lowSeason,
            growth: parseFloat(growth.toFixed(1))
          },
          destinationsData: destinationsData.sort((a, b) => b.bookings - a.bookings),
          reservationCharts: [
            {
              title: 'Évolution des réservations',
              data: chartData
            }
          ]
        };
        
        setReportData(reportData);
        setLoading(false);
        
      } catch (err) {
        console.error('Error generating report:', err);
        setError('Une erreur est survenue lors de la génération du rapport');
        setLoading(false);
        
        // Return fallback data in case of error
        const fallbackData = {
          total: 0,
          confirmed: 0,
          pending: 0,
          cancelled: 0,
          revenue: 0,
          averageValue: 0,
          conversionRate: 85.5,
          cancelationRate: 3.2,
          repeatCustomers: 65.8,
          seasonalTrends: {
            peak: 'June-August',
            low: 'January-February',
            growth: 23.5
          },
          destinationsData: [
            {
              name: 'Paris, France',
              bookings: 235,
              revenue: 17250000,
              avgPrice: 73404,
              satisfaction: 4.8,
              repeatRate: 72,
              cancelRate: 2,
              seasonality: 'Haute saison: Mai-Septembre',
              topServices: ['Visites guidées', 'Transferts', 'Hébergement'],
              clientProfile: 'Couples, 30-50 ans',
              growth: 24,
              color: '#1e40af'
            },
            {
              name: 'Istanbul, Turquie',
              bookings: 187,
              revenue: 15895000,
              avgPrice: 85000,
              satisfaction: 4.7,
              repeatRate: 68,
              cancelRate: 3,
              seasonality: 'Haute saison: Avril-Octobre',
              topServices: ['Vol A/R', 'Hôtel 4*', 'Visites guidées'],
              clientProfile: 'Familles et couples, 25-45 ans',
              growth: 18,
              color: '#059669'
            }
          ],
          reservationCharts: [
            {
              title: 'Évolution des réservations',
              data: [
                { name: 'Jan', value: 125 },
                { name: 'Fév', value: 175 },
                { name: 'Mar', value: 228 },
                { name: 'Avr', value: 265 },
                { name: 'Mai', value: 332 },
                { name: 'Juin', value: 378 },
                { name: 'Juil', value: 425 },
                { name: 'Août', value: 386 },
                { name: 'Sept', value: 344 },
                { name: 'Oct', value: 278 },
                { name: 'Nov', value: 232 },
                { name: 'Déc', value: 178 }
              ]
            }
          ]
        };
        
        setReportData(fallbackData);
      }
    };
    
    generateReport();
  }, [reservations, clients, packages, transactions, reservationsStats, reservationsLoading, clientsLoading, packagesLoading, financialLoading, period, destination]);
  
  return { reportData, loading, error };
};

// Dashboard data hook that consolidates data from other hooks for real-time dashboard updates
export const useDashboardData = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [updateCounter, setUpdateCounter] = useState(0);
  const [lastRefresh, setLastRefresh] = useState(Date.now());
  
  // Get data from all sources with forced refresh
  const { reservations, loading: reservationsLoading } = useReservationsData({ forceRefresh: updateCounter });
  const { clients, loading: clientsLoading } = useClientsData({ forceRefresh: updateCounter });
  const { packages, loading: packagesLoading } = usePackagesData({ forceRefresh: updateCounter });
  
  // CRITICAL: Get financial data with stats to ensure dashboard uses the EXACT SAME values
  const { transactions, loading: financialLoading, stats: financialStats } = useFinancialData({ forceRefresh: updateCounter });
  const { reportData, loading: reportLoading } = useReservationsReportData('year', 'all', updateCounter);
  
  // Force immediate refresh on mount
  useEffect(() => {
    console.log('Dashboard mounted - forcing immediate data refresh');
    setUpdateCounter(Date.now());
    invalidateCache('dashboard');
  }, []);
  
  // Enhanced listener for all data changes with improved logging
  useEffect(() => {
    const handleDashboardUpdate = (e) => {
      console.log("Dashboard direct update event received:", e.detail);
      setUpdateCounter(Date.now()); // Use timestamp for more unique updates
      setLastRefresh(Date.now());
      invalidateCache('dashboard');
    };
    
    const handleDataVersionChange = (e) => {
      console.log("Data version change detected:", e.detail);
      // Always update dashboard when any data changes
      setUpdateCounter(Date.now());
      setLastRefresh(Date.now());
      
      // Force invalidation of dashboard cache
      invalidateCache('dashboard');
    };
    
    const handleGlobalDataRefresh = (e) => {
      console.log("Global data refresh event received:", e.detail);
      setUpdateCounter(Date.now());
      setLastRefresh(Date.now());
      
      // Force invalidation of all caches
      Object.keys(dataCache).forEach(key => {
        dataCache[key] = { data: null, timestamp: null, version: ++globalDataVersion[key] };
      });
    };
    
    const handleStorageChange = (e) => {
      console.log("Storage change detected:", e.key);
      if (e.key && (e.key.includes('Data') || e.key === 'dataCache')) {
        setUpdateCounter(Date.now());
        setLastRefresh(Date.now());
        invalidateCache('dashboard');
      }
    };
    
    // NEW: Listen for shared state updates to ensure real-time data
    const handleSharedStateUpdate = (e) => {
      console.log("Shared state update detected:", e.detail);
      // Immediately update when shared state changes
      setUpdateCounter(Date.now());
      setLastRefresh(Date.now());
      
      // Force dashboard refresh
      invalidateCache('dashboard');
    };
    
    // Listen for all relevant events
    window.addEventListener('dashboardUpdate', handleDashboardUpdate);
    window.addEventListener('dataVersionChange', handleDataVersionChange);
    window.addEventListener('globalDataRefresh', handleGlobalDataRefresh);
    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('sharedStateUpdate', handleSharedStateUpdate);
    
    // Force initial data refresh
    setUpdateCounter(Date.now());
    
    // Set up automatic refresh every 3 seconds for more real-time updates
    const refreshInterval = setInterval(() => {
      console.log("Dashboard auto-refresh triggered");
      setUpdateCounter(Date.now());
      setLastRefresh(Date.now());
      invalidateCache('dashboard');
    }, 3000);
    
    return () => {
      window.removeEventListener('dashboardUpdate', handleDashboardUpdate);
      window.removeEventListener('dataVersionChange', handleDataVersionChange);
      window.removeEventListener('globalDataRefresh', handleGlobalDataRefresh);
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('sharedStateUpdate', handleSharedStateUpdate);
      clearInterval(refreshInterval);
    };
  }, []);

  useEffect(() => {
    const generateDashboardData = async () => {
      console.log(`Generating dashboard data... (refresh #${updateCounter}, last: ${new Date(lastRefresh).toLocaleTimeString()})`);
      
      // Force clear all caches periodically to ensure fresh data
      if (updateCounter % 3 === 0) { // Every 3rd refresh
        console.log('Forcing complete cache refresh');
        Object.keys(dataCache).forEach(key => {
          dataCache[key] = { data: null, timestamp: null, version: ++globalDataVersion[key] };
        });
      }
      
      // Wait for all data to load
      if (reservationsLoading || clientsLoading || packagesLoading || financialLoading || reportLoading) {
        setLoading(true);
        return;
      }
      
      try {
        // Calculate stats from actual data
        const totalClients = clients ? clients.length : 5;
        const totalReservations = reservations ? reservations.length : 6;
        const confirmedReservations = reservations ? reservations.filter(r => r.statut === 'Confirmée').length : 4;
        const pendingReservations = reservations ? reservations.filter(r => r.statut === 'En attente').length : 2;
        const canceledReservations = reservations ? reservations.filter(r => r.statut === 'Annulée').length : 0;
        
        // CRITICAL FIX: Use the EXACT SAME revenue value from the finances page
        // instead of recalculating it differently here
        // First check shared state, then fallback to financialStats
        const totalRevenue = sharedAppState.financial.totalRevenue || (financialStats ? financialStats.totalRevenue : 0);
          
        console.log("Dashboard using finance page revenue:", totalRevenue, "from", transactions?.length, "transactions");

        // Mock satisfaction data - would come from reviews
        const avgSatisfaction = 94.2; 
        
        // Calculate conversion rate (confirmed/total)
        const conversionRate = totalReservations > 0 
          ? (confirmedReservations / totalReservations) * 100 
          : 66.7;

        // Generate notifications based on real data
        const notifications = generateNotifications(reservations || [], transactions || []);
        
        // Generate upcoming trips based on real reservations
        const upcomingTrips = generateUpcomingTrips(reservations || [], clients || [], packages || []);
        
        // Create chart data
        const revenueChartData = generateMonthlyRevenueData(transactions || []);
        const bookingChartData = generateMonthlyBookingData(reservations || []);
        const satisfactionChartData = generateMonthlySatisfactionData(); // Mock data for now
        
        // Store the dashboard data with real-time values from other pages
        const dashboardStats = {
          stats: {
            clients: totalClients,
            reservations: totalReservations,
            revenus: totalRevenue,
            forfaits: packages ? packages.length : 6,
            satisfaction: avgSatisfaction,
            conversion: parseFloat(conversionRate.toFixed(1))
          },
          notifications,
          upcomingTrips,
          chartData: {
            revenue: revenueChartData,
            bookings: bookingChartData,
            satisfaction: satisfactionChartData
          },
          reportData,
          // Include timestamp to track when this data was generated
          lastUpdated: Date.now()
        };
        
        // Save dashboard data to localStorage for persistence
        localStorage.setItem('dashboardData', JSON.stringify(dashboardStats));
        
        setDashboardData(dashboardStats);
        
        setLoading(false);
      } catch (err) {
        setError('Une erreur est survenue lors de la génération des données du tableau de bord');
        console.error('Error generating dashboard data:', err);
        setLoading(false);
      }
    };
    
    generateDashboardData();
  }, [
    reservations, clients, packages, transactions, 
    reservationsLoading, clientsLoading, packagesLoading, financialLoading,
    reportData, reportLoading,
    // Force refresh when transactions are updated or dashboard update is triggered
    transactions?.length, updateCounter, lastRefresh
  ]);
  
  return { dashboardData, loading, error };
};

// New hook to provide sidebar counts for navigation menu
export const useSidebarCounts = () => {
  const [counts, setCounts] = useState({
    clients: 0,
    reservations: 0,
    forfaits: 0,
    documents: 5 // Fixed to 5 documents
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Get data from other hooks to ensure consistency
  const { clients, loading: clientsLoading } = useClientsData();
  const { reservations, loading: reservationsLoading } = useReservationsData();
  const { packages, loading: packagesLoading } = usePackagesData();

  useEffect(() => {
    const generateCounts = () => {
      try {
        // Only update counts when all data is loaded
        if (!clientsLoading && !reservationsLoading && !packagesLoading) {
          const countsData = {
            clients: clients ? clients.length : 5,
            reservations: reservations ? reservations.length : 6,
            forfaits: packages ? packages.length : 6,
            documents: 5 // Fixed to 5 documents
          };
          
          setCounts(countsData);
          
          // Cache the data
          dataCache.counts = {
            data: countsData,
            timestamp: Date.now()
          };
          
          setLoading(false);
        }
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    generateCounts();
  }, [clients, reservations, packages, clientsLoading, reservationsLoading, packagesLoading]);

  return { counts, loading, error };
};

// Helper function to generate notifications based on real data
const generateNotifications = (reservations, financial) => {
  const notifications = [];
  
  // Get most recent confirmed reservations
  const recentConfirmed = [...reservations]
    .filter(r => r.statut === 'Confirmée')
    .sort((a, b) => new Date(b.dateReservation) - new Date(a.dateReservation))
    .slice(0, 2);
  
  recentConfirmed.forEach((res, index) => {
    notifications.push({
      id: `notif-${index + 1}`,
      type: 'success',
      title: 'Nouvelle réservation confirmée',
      message: `${res.clientNom} - ${res.forfait}`,
      time: 'Il y a 2 min',
      amount: `${(res.prixTotal / 1000).toFixed(0)},000 DA`,
      avatar: '/api/placeholder/32/32',
      action: () => {}
    });
  });
  
  // Get pending payments
  const pendingPayments = [...reservations]
    .filter(r => r.statutPaiement === 'En attente')
    .slice(0, 1);
  
  pendingPayments.forEach(res => {
    notifications.push({
      id: 'notif-pending-1',
      type: 'warning',
      title: 'Paiement en attente',
      message: `${res.clientNom} - ${res.forfait}`,
      time: 'Il y a 15 min',
      amount: `${(res.prixTotal / 1000).toFixed(0)},000 DA`,
      avatar: '/api/placeholder/32/32',
      action: () => {}
    });
  });
  
  // Add some fixed notifications (demo purpose only)
  notifications.push({
    id: 'notif-departure-1',
    type: 'info',
    title: 'Rappel départ demain',
    message: 'Groupe Omra - Vol 14h30',
    time: 'Il y a 1h',
    participants: 24,
    avatar: '/api/placeholder/32/32',
    action: () => {}
  });
  
  notifications.push({
    id: 'notif-error-1',
    type: 'error',
    title: 'Problème vol retardé',
    message: 'Air Algérie AH1205 - Retard 2h',
    time: 'Il y a 2h',
    affected: 18,
    avatar: '/api/placeholder/32/32',
    action: () => {}
  });
  
  return notifications;
};

// Helper function to generate upcoming trips based on real data
const generateUpcomingTrips = (reservations, clients, packages) => {
  // Get upcoming departures ordered by date
  const upcoming = [...reservations]
    .filter(res => {
      const departDate = new Date(res.dateDepart);
      const now = new Date();
      return departDate > now && res.statut !== 'Annulée';
    })
    .sort((a, b) => new Date(a.dateDepart) - new Date(b.dateDepart))
    .slice(0, 4);
  
  return upcoming.map(res => {
    // Find client
    const client = clients.find(c => c.id === res.clientId) || {};
    
    // Find package
    const pkg = packages.find(p => p.id === res.forfaitId) || {};
    
    // Map country to flag emoji (simplified)
    const getFlag = (destination) => {
      if (destination.includes('Turquie')) return '🇹🇷';
      if (destination.includes('France')) return '🇫🇷';
      if (destination.includes('Arabie Saoudite')) return '🇸🇦';
      if (destination.includes('EAU')) return '🇦🇪';
      if (destination.includes('Italie')) return '🇮🇹';
      if (destination.includes('Maroc')) return '🇲🇦';
      return '🌍';
    };
    
    return {
      id: res.id,
      destination: res.destination,
      client: `${client.prenom || ''} ${client.nom || ''}`.trim() || res.clientNom,
      date: res.dateDepart,
      statut: res.statut,
      participants: res.nombrePassagers,
      package: res.forfait,
      revenue: res.prixTotal,
      avatar: '/api/placeholder/40/40',
      flag: getFlag(res.destination)
    };
  });
};

// Helper function to generate monthly revenue data - Make it deterministic, not random
const generateMonthlyRevenueData = (financialData) => {
  // First check if we have financial data to use
  if (financialData && financialData.length > 0) {
    const monthlyRevenue = Array(12).fill(0);
    
    financialData.forEach(txn => {
      if (txn.type === 'Recette') {
        const date = new Date(txn.date);
        const month = date.getMonth();
        monthlyRevenue[month] += txn.montant / 1000; // Scale down for better visualization
      }
    });
    
    return monthlyRevenue;
  } else {
    // Use fixed data when no real data is available
    return [45, 52, 48, 61, 55, 67, 62, 74, 69, 78, 72, 84];
  }
};

// Helper function to generate monthly booking data - Make it deterministic, not random
const generateMonthlyBookingData = (reservationsData) => {
  // First check if we have reservations data to use
  if (reservationsData && reservationsData.length > 0) {
    const monthlyBookings = Array(12).fill(0);
    
    reservationsData.forEach(res => {
      const date = new Date(res.dateReservation);
      const month = date.getMonth();
      monthlyBookings[month] += 1;
    });
    
    return monthlyBookings;
  } else {
    // Use fixed data when no real data is available
    return [12, 19, 15, 23, 20, 28, 25, 32, 29, 35, 33, 41];
  }
};

// Helper function to generate monthly satisfaction data - Use fixed data instead of random
const generateMonthlySatisfactionData = () => {
  return [85, 88, 91, 89, 93, 90, 94, 92, 95, 94, 96, 94];
};

// Calendar events data hook that consolidates data from other hooks for real-time calendar updates
export const useCalendarData = (filters = {}) => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [stats, setStats] = useState({
    totalEvents: 0,
    upcomingEvents: 0,
    revenueFromEvents: 0,
    eventsByType: {}
  });
  
  // Get related data from other services for interconnection
  const { reservations, loading: reservationsLoading } = useReservationsData();
  const { clients, loading: clientsLoading } = useClientsData();
  const { packages, loading: packagesLoading } = usePackagesData();
  const { suppliers, loading: suppliersLoading } = useSuppliersData();
  
  // Add a state to track when to force refresh
  const [forceRefresh, setForceRefresh] = useState(0);
  
  // Event handler for calendar data updates
  const handleCalendarDataUpdate = useCallback((e) => {
    console.log('Calendar data update event received');
    setForceRefresh(prev => prev + 1);
  }, []);
  
  // Event handler for localStorage changes
  const handleStorageChange = useCallback((e) => {
    if (e.key === 'calendarEvents' || e.key === 'dataCache') {
      console.log('Storage change detected for calendar data');
      setForceRefresh(prev => prev + 1);
    }
  }, []);
  
  // Set up event listeners
  useEffect(() => {
    window.addEventListener('calendarDataUpdate', handleCalendarDataUpdate);
    window.addEventListener('storage', handleStorageChange);
    
    return () => {
      window.removeEventListener('calendarDataUpdate', handleCalendarDataUpdate);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [handleCalendarDataUpdate, handleStorageChange]);

  useEffect(() => {
    const generateCalendarEvents = async () => {
      try {
        setLoading(true);

        // Check if we have valid cached data and we're not forcing a refresh
        if (isCacheValid('calendarEvents') && forceRefresh === 0) {
          const cachedData = dataCache.calendarEvents;
          setEvents(cachedData.data);
          setStats(cachedData.stats);
          setLoading(false);
          return;
        }

        // Wait until all data is loaded
        if (reservationsLoading || clientsLoading || packagesLoading || suppliersLoading) {
          return;
        }
        
        // First check for user-created events in localStorage
        const userCreatedEvents = JSON.parse(localStorage.getItem('calendarEvents') || '[]');
        
        // Generate events from reservations
        let generatedEvents = [];
        
        // Process departure events
        const departureEvents = reservations.map(reservation => {
          // Find related data
          const client = clients.find(c => c.id === reservation.clientId);
          const package_ = packages.find(p => p.id === reservation.forfaitId);
          
          // Find supplier based on destination matching
          const supplier = suppliers?.find(s => 
            s.pays === package_?.destination?.split(',')[1]?.trim() ||
            s.type === 'Compagnie aérienne'
          );
          
          // Create departure event
          return {
            id: `DEP-${reservation.id}`,
            titre: `Départ ${reservation.destination} - ${reservation.clientNom}`,
            type: 'Départ',
            date: reservation.dateDepart,
            heure: '10:00', // Default time
            client: client,
            package: package_,
            reservation: reservation.id,
            destination: reservation.destination,
            statut: reservation.statut === 'Confirmée' ? 'Confirmé' : 
                   reservation.statut === 'En attente' ? 'En attente' : 'Annulé',
            couleur: reservation.statut === 'Confirmée' ? 'success' : 
                    reservation.statut === 'En attente' ? 'warning' : 'error',
            description: `Départ pour ${reservation.forfait}`,
            revenue: reservation.prixTotal,
            participants: reservation.nombrePassagers,
            supplier: supplier?.nom || 'Non défini'
          };
        });
        
        // Process return events
        const returnEvents = reservations.map(reservation => {
          // Find related data
          const client = clients.find(c => c.id === reservation.clientId);
          const package_ = packages.find(p => p.id === reservation.forfaitId);
          
          // Find supplier based on destination matching
          const supplier = suppliers?.find(s => 
            s.pays === package_?.destination?.split(',')[1]?.trim() ||
            s.type === 'Compagnie aérienne'
          );
          
          // Create return event (a week after departure by default)
          const departDate = new Date(reservation.dateDepart);
          const returnDate = new Date(departDate);
          
          // Calculate return date based on package duration if available
          if (package_ && package_.duree) {
            const durationMatch = package_.duree.match(/(\d+)\s+jours/i);
            if (durationMatch && durationMatch[1]) {
              const days = parseInt(durationMatch[1]);
              returnDate.setDate(departDate.getDate() + days);
            } else {
              // Default to 7 days later
              returnDate.setDate(departDate.getDate() + 7);
            }
          } else {
            // Default to 7 days later
            returnDate.setDate(departDate.getDate() + 7);
          }
          
          return {
            id: `RET-${reservation.id}`,
            titre: `Retour ${reservation.destination} - ${reservation.clientNom}`,
            type: 'Retour',
            date: returnDate.toISOString().split('T')[0],
            heure: '18:00', // Default time
            client: client,
            package: package_,
            reservation: reservation.id,
            destination: reservation.destination,
            statut: reservation.statut === 'Confirmée' ? 'Confirmé' : 
                   reservation.statut === 'En attente' ? 'En attente' : 'Annulé',
            couleur: reservation.statut === 'Confirmée' ? 'primary' : 
                    reservation.statut === 'En attente' ? 'warning' : 'error',
            description: `Retour de ${reservation.forfait}`,
            revenue: 0, // No additional revenue for return
            participants: reservation.nombrePassagers,
            supplier: supplier?.nom || 'Non défini'
          };
        });
        
        // Add professional events
        const professionalEvents = [
          {
            id: 'PRO-001',
            titre: 'Réunion fournisseurs',
            type: 'Professionnel',
            date: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
            heure: '14:00',
            client: null,
            package: null,
            reservation: null,
            destination: 'Bureau Alger',
            statut: 'Planifié',
            couleur: 'info',
            description: 'Réunion trimestrielle avec les partenaires hôteliers',
            revenue: 0,
            participants: suppliers?.filter(s => s.type === 'Hôtel').length || 5,
            supplier: 'Équipe TravelIT'
          },
          {
            id: 'PRO-002',
            titre: 'Formation équipe',
            type: 'Formation',
            date: new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
            heure: '09:00',
            client: null,
            package: null,
            reservation: null,
            destination: 'Bureau Alger',
            statut: 'Planifié',
            couleur: 'secondary',
            description: 'Formation sur les nouveaux systèmes de réservation',
            revenue: 0,
            participants: 12,
            supplier: 'Équipe TravelIT'
          },
          {
            id: 'PRO-003',
            titre: 'Salon du Tourisme',
            type: 'Événement',
            date: new Date(Date.now() + 21 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
            heure: '10:00',
            client: null,
            package: null,
            reservation: null,
            destination: 'Centre des Expositions, Alger',
            statut: 'Confirmé',
            couleur: 'error',
            description: 'Participation au salon international du tourisme',
            revenue: 0,
            participants: 6,
            supplier: 'TravelIT'
          }
        ];
        
        // Combine all events - user created events take precedence
        generatedEvents = [...departureEvents, ...returnEvents, ...professionalEvents, ...userCreatedEvents];
        
        // Remove duplicates by ID
        const uniqueEvents = [];
        const seenIds = new Set();
        
        generatedEvents.forEach(event => {
          if (!seenIds.has(event.id)) {
            seenIds.add(event.id);
            uniqueEvents.push(event);
          }
        });
        
        generatedEvents = uniqueEvents;
        
        // Apply filters if needed
        if (filters.eventType) {
          generatedEvents = generatedEvents.filter(event => event.type === filters.eventType);
        }
        
        if (filters.startDate && filters.endDate) {
          generatedEvents = generatedEvents.filter(event => {
            const eventDate = new Date(event.date);
            return eventDate >= new Date(filters.startDate) && eventDate <= new Date(filters.endDate);
          });
        }
        
        if (filters.client) {
          generatedEvents = generatedEvents.filter(event => 
            event.client && event.client.id === filters.client
          );
        }
        
        // Calculate statistics
        const now = new Date();
        const totalEvents = generatedEvents.length;
        const upcomingEvents = generatedEvents.filter(e => new Date(e.date) >= now).length;
        const revenueFromEvents = generatedEvents.reduce((sum, e) => sum + (e.revenue || 0), 0);
        
        // Count events by type
        const eventsByType = generatedEvents.reduce((acc, e) => {
          acc[e.type] = (acc[e.type] || 0) + 1;
          return acc;
        }, {});
        
        const statsData = {
          totalEvents,
          upcomingEvents,
          revenueFromEvents,
          eventsByType
        };
        
        // Update state
        setEvents(generatedEvents);
        setStats(statsData);
        
        // Cache the data
        dataCache.calendarEvents = {
          data: generatedEvents,
          stats: statsData,
          timestamp: Date.now()
        };
        
        setLoading(false);
      } catch (err) {
        console.error("Error generating calendar events:", err);
        setError("Une erreur est survenue lors de la génération des événements du calendrier");
        setLoading(false);
      }
    };
    
    generateCalendarEvents();
  }, [
    reservations, clients, packages, suppliers,
    reservationsLoading, clientsLoading, packagesLoading, suppliersLoading,
    filters, forceRefresh
  ]);
  
  return { events, loading, error, stats };
};

export const useSuppliersData = (filters = {}) => {
  // Use the base suppliers hook that doesn't have financial data dependency
  const baseData = useBaseSuppliersData(filters);
  const { suppliers, loading: suppliersLoading, error, stats: baseStats } = baseData;
  
  // Only get financial data if not skipped
  const [stats, setStats] = useState(baseStats);
  const [loading, setLoading] = useState(true);
  
  // Always call useFinancialData unconditionally
  const financialData = useFinancialData();
  // Only use the data if not skipped
  const transactions = filters.skipFinancial ? [] : (financialData?.transactions || []);
  const transactionsLoading = filters.skipFinancial ? false : (financialData?.loading || false);
  
  // Update stats with financial data if available
  useEffect(() => {
    if (!filters.skipFinancial && !transactionsLoading && transactions.length > 0) {
      // Calculate additional financial stats
      const supplierPayments = transactions
        .filter(t => t.type === 'Dépense' && t.categorie === 'Fournisseur')
        .reduce((acc, t) => {
          if (!acc[t.fournisseurId]) {
            acc[t.fournisseurId] = 0;
          }
          acc[t.fournisseurId] += t.montant;
          return acc;
        }, {});
        
      // Update stats
      setStats({
        ...baseStats,
        supplierPayments
      });
    } else {
      setStats(baseStats);
    }
    
    setLoading(suppliersLoading || (!filters.skipFinancial && transactionsLoading));
  }, [baseStats, suppliersLoading, transactions, transactionsLoading, filters.skipFinancial]);
  
  return { suppliers, loading, error, stats };
};

// Create a base suppliers hook that doesn't depend on financial data
export const useBaseSuppliersData = (filters = {}) => {
  const [suppliers, setSuppliers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [stats, setStats] = useState({});
  const cacheKey = 'suppliersData';
  
  // For cache invalidation tracking
  const [forceUpdate, setForceUpdate] = useState(0);

  // Get related data from other services for interconnection
  const { packages, loading: packagesLoading } = usePackagesData();
  const { reservations, loading: reservationsLoading } = useReservationsData();

  // Function to load suppliers data from localStorage
  const loadSuppliersFromStorage = useCallback(() => {
    try {
      // CRITICAL FIX: Always get fresh data from localStorage
      console.log("Loading suppliers directly from localStorage");
      const storedSuppliers = JSON.parse(localStorage.getItem('suppliersData') || '[]');
      
      // CRITICAL FIX: Immediately update component state with this data
      setSuppliers(storedSuppliers);
      
      // CRITICAL FIX: Also update the dataCache so any other components using it get fresh data
      dataCache[cacheKey] = {
        data: storedSuppliers,
        stats: stats,
        timestamp: Date.now() // Update timestamp to show it's fresh
      };
      
      return storedSuppliers;
    } catch (error) {
      console.error('Error loading suppliers from localStorage:', error);
      return [];
    }
  }, [stats]);

  // CRITICAL FIX: Added a separate useEffect just for localStorage updates
  // This ensures we respond immediately to any localStorage changes
  useEffect(() => {
    // Add storage event listener to update data when localStorage changes
    const handleStorageChange = (e) => {
      if (e.key === 'suppliersData') {
        console.log("Storage event detected for suppliers data");
        loadSuppliersFromStorage();
      }
    };
    
    // Custom event for direct updates (when localStorage is updated in the same window)
    const handleSupplierDataUpdate = (e) => {
      console.log("Supplier data update event received");
      
      // CRITICAL FIX: If the event contains complete supplier data, use it directly
      if (e.detail && e.detail.allSuppliers && Array.isArray(e.detail.allSuppliers)) {
        setSuppliers(e.detail.allSuppliers);
        
        // Also update dataCache
        dataCache[cacheKey] = {
          data: e.detail.allSuppliers,
          stats: stats,
          timestamp: Date.now()
        };
      } else {
        // Otherwise reload from localStorage
        loadSuppliersFromStorage();
      }
      
      // Force a rerender cycle with fresh data by incrementing the counter
      setForceUpdate(prev => prev + 1);
    };
    
    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('supplierDataUpdate', handleSupplierDataUpdate);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('supplierDataUpdate', handleSupplierDataUpdate);
    };
  }, [loadSuppliersFromStorage, stats]);

  // Main data loading effect
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        
        // CRITICAL FIX: Skip cache validation and always load fresh data
        // This prevents stale data from being shown
        const storedSuppliers = loadSuppliersFromStorage();
        
        if (storedSuppliers.length > 0) {
          // CRITICAL FIX: Even though we already updated the state in loadSuppliersFromStorage,
          // setting it here again ensures the component gets fresh data
          setSuppliers(storedSuppliers);
          setLoading(false);
          return;
        }
        
        // If there's no localStorage data, try API (fallback path)
        try {
          const response = await fetch('/api/suppliers');
          if (!response.ok) throw new Error('Erreur serveur');
          const data = await response.json();
          
          // Update with real data
          setSuppliers(data.data || []);
          
          // Cache the data
          dataCache[cacheKey] = {
            data: data.data || [],
            stats: stats,
            timestamp: Date.now()
          };
          
          // Also save to localStorage for future use
          localStorage.setItem('suppliersData', JSON.stringify(data.data || []));
          
        } catch (error) {
          console.error("API error:", error);
          
          // Fallback to localStorage
          loadSuppliersFromStorage();
        }
        
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchData();
  }, [loadSuppliersFromStorage, filters.type, filters.destination, forceUpdate]);

  return { suppliers, loading, error, stats };
};

// Documents data hook that integrates with other data sources
export const useDocumentsData = (filters = {}) => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [stats, setStats] = useState({
    total: 0,
    clientDocs: 0,
    contracts: 0,
    pending: 0
  });
  
  // Add a state to track when to force refresh
  const [forceRefresh, setForceRefresh] = useState(0);

  // Get related data from other services for interconnection
  const { clients, loading: clientsLoading } = useClientsData();
  const { reservations, loading: reservationsLoading } = useReservationsData();
  const { suppliers, loading: suppliersLoading } = useBaseSuppliersData({ skipFinancial: true });
  const { packages, loading: packagesLoading } = usePackagesData();

  // Event handler for document data updates
  const handleDocumentDataUpdate = useCallback((e) => {
    console.log('Document data update event received');
    if (e.detail && e.detail.documents) {
      setDocuments(e.detail.documents);
      
      // Update stats
      const total = e.detail.documents.length;
      const clientDocs = e.detail.documents.filter(d => d.categorie === 'clients').length;
      const contracts = e.detail.documents.filter(d => d.type === 'contrat').length;
      const pending = e.detail.documents.filter(d => d.statut === 'en_attente').length;
      
      setStats({
        total,
        clientDocs,
        contracts,
        pending
      });
    } else {
      setForceRefresh(prev => prev + 1);
    }
  }, []);
  
  // Event handler for localStorage changes
  const handleStorageChange = useCallback((e) => {
    if (e.key === 'documentsData' || e.key === 'dataCache') {
      console.log('Storage change detected for document data');
      setForceRefresh(prev => prev + 1);
    }
  }, []);
  
  // Set up event listeners
  useEffect(() => {
    window.addEventListener('documentDataUpdate', handleDocumentDataUpdate);
    window.addEventListener('storage', handleStorageChange);
    
    return () => {
      window.removeEventListener('documentDataUpdate', handleDocumentDataUpdate);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [handleDocumentDataUpdate, handleStorageChange]);

  // Main data fetching effect
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        
        // First check for documents in localStorage
        const localDocuments = localStorage.getItem('documentsData');
        if (localDocuments) {
          console.log("Loading documents from localStorage");
          const parsedDocuments = JSON.parse(localDocuments);
          setDocuments(parsedDocuments);
          
          // Calculate stats
          const total = parsedDocuments.length;
          const clientDocs = parsedDocuments.filter(d => d.categorie === 'clients').length;
          const contracts = parsedDocuments.filter(d => d.type === 'contrat').length;
          const pending = parsedDocuments.filter(d => d.statut === 'en_attente').length;
          
          setStats({
            total,
            clientDocs,
            contracts,
            pending
          });
          
          setLoading(false);
          return;
        }
        
        // If no localStorage data, use cache if valid
        if (isCacheValid('documents')) {
          const documentsData = dataCache.documents.data;
          setDocuments(documentsData);
          setStats(dataCache.documents.stats);
          setLoading(false);
          return;
        }
        
        // Wait until all data is loaded
        if (clientsLoading || reservationsLoading || suppliersLoading || packagesLoading) {
          return;
        }
        
        // Generate documents data based on other entities
          const generatedDocuments = generateDocumentsData(clients, reservations, suppliers, packages);
          
          // Apply filters if needed
          let filteredDocuments = [...generatedDocuments];
          
          if (filters.category) {
            filteredDocuments = filteredDocuments.filter(d => d.categorie === filters.category);
          }
          
          if (filters.type) {
            filteredDocuments = filteredDocuments.filter(d => d.type === filters.type);
          }
          
          if (filters.search) {
            const searchTerm = filters.search.toLowerCase();
            filteredDocuments = filteredDocuments.filter(d => 
              d.nom.toLowerCase().includes(searchTerm) || 
              d.proprietaire.toLowerCase().includes(searchTerm) ||
              d.description.toLowerCase().includes(searchTerm)
            );
          }
          
          setDocuments(filteredDocuments);
          
          // Calculate stats
          const total = filteredDocuments.length;
          const clientDocs = filteredDocuments.filter(d => d.categorie === 'clients').length;
          const contracts = filteredDocuments.filter(d => d.type === 'contrat').length;
          const pending = filteredDocuments.filter(d => d.statut === 'en_attente').length;
          
          const statsData = {
            total,
            clientDocs,
            contracts,
            pending
          };
          
          setStats(statsData);
          
          // Cache the data
          dataCache.documents = {
            data: filteredDocuments,
            stats: statsData,
            timestamp: Date.now()
          };
        
        // Save to localStorage for future use
        localStorage.setItem('documentsData', JSON.stringify(filteredDocuments));
        
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchData();
  }, [
    clients, reservations, suppliers, packages,
    clientsLoading, reservationsLoading, suppliersLoading, packagesLoading,
    filters.category, filters.type, filters.search, forceRefresh
  ]);

  // Add function to upload a document
  const uploadDocument = async (documentData, file) => {
    try {
      // In a real application, this would be an API call with FormData
      // For now, we'll simulate the API call and update the cache
      
      // Convert file to base64 for all file types to ensure proper storage
      const fileBase64 = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(file);
      });
      
      // Create a new document object
      const newDocument = {
        id: `DOC-${Date.now()}`,
        nom: documentData.nom,
        type: documentData.type,
        categorie: documentData.categorie,
        taille: `${(file.size / (1024 * 1024)).toFixed(2)} MB`,
        dateCreation: documentData.dateCreation || new Date().toISOString().split('T')[0],
        proprietaire: documentData.proprietaire || 'Utilisateur',
        statut: documentData.statut || 'actif',
        description: documentData.description || `Document ${documentData.type}`,
        fileData: {
          data: fileBase64,
          type: file.type,
          size: file.size,
          lastModified: file.lastModified
        }
      };
      
      // Update the documents cache
      const updatedDocuments = [newDocument, ...documents];
      setDocuments(updatedDocuments);
      
      // Update stats
      const updatedStats = {
        total: stats.total + 1,
        clientDocs: documentData.categorie === 'clients' ? stats.clientDocs + 1 : stats.clientDocs,
        contracts: documentData.type === 'contrat' ? stats.contracts + 1 : stats.contracts,
        pending: documentData.statut === 'en_attente' ? stats.pending + 1 : stats.pending
      };
      setStats(updatedStats);
      
      // Update the cache
      dataCache.documents = {
        data: updatedDocuments,
        stats: updatedStats,
        timestamp: Date.now()
      };
      
      // Save to localStorage
      localStorage.setItem('documentsData', JSON.stringify(updatedDocuments));
      
      // Dispatch event to notify other components
      window.dispatchEvent(new CustomEvent('documentDataUpdate', {
        detail: { documents: updatedDocuments }
      }));
      
      return { success: true, document: newDocument };
    } catch (error) {
      console.error("Error uploading document:", error);
      return { success: false, error: error.message };
    }
  };

  return { documents, loading, error, stats, uploadDocument };
};

/**
 * Generate comprehensive document data based on clients, reservations, suppliers and packages
 */
const generateDocumentsData = (clients, reservations, suppliers, packages) => {
  const documents = [];
  
  // 1. Generate client documents (passports, visas, etc.)
  clients.forEach(client => {
    // Passport document
    documents.push({
      id: `DOC-PASS-${client.id}`,
      nom: `Passeport_${client.nom.toUpperCase()}_${client.prenom}.pdf`,
      type: 'passeport',
      categorie: 'clients',
      taille: `${Math.round(0.5 + Math.random() * 2.5)} MB`,
      dateCreation: new Date(Date.now() - Math.random() * 7776000000).toISOString().split('T')[0], // Random date in last 90 days
      proprietaire: `${client.prenom} ${client.nom}`,
      statut: Math.random() > 0.2 ? 'validé' : 'en_attente',
      description: `Copie du passeport de ${client.prenom} ${client.nom}`,
      reference: {
        entite: 'Client',
        id: client.id
      }
    });
    
    // Only add visa for some clients (those with international travel preferences)
    if (client.preferencesVoyage?.some(p => p === 'Culturel' || p === 'Business')) {
      documents.push({
        id: `DOC-VISA-${client.id}`,
        nom: `Visa_Schengen_${client.nom.toUpperCase()}.jpg`,
        type: 'visa',
        categorie: 'clients',
        taille: `${Math.round(0.5 + Math.random())} MB`,
        dateCreation: new Date(Date.now() - Math.random() * 7776000000).toISOString().split('T')[0],
        proprietaire: `${client.prenom} ${client.nom}`,
        statut: Math.random() > 0.3 ? 'validé' : 'en_attente',
        description: `Visa Schengen pour voyage en Europe`,
        reference: {
          entite: 'Client',
          id: client.id
        }
      });
    }
    
    // Add ID card for all clients
    documents.push({
      id: `DOC-ID-${client.id}`,
      nom: `CIN_${client.nom.toUpperCase()}_${client.prenom}.jpg`,
      type: 'certificat',
      categorie: 'clients',
      taille: `${Math.round(0.3 + Math.random() * 0.5)} MB`,
      dateCreation: new Date(Date.now() - Math.random() * 7776000000).toISOString().split('T')[0],
      proprietaire: `${client.prenom} ${client.nom}`,
      statut: 'validé',
      description: `Carte d'identité nationale`,
      reference: {
        entite: 'Client',
        id: client.id
      }
    });
  });
  
  // 2. Generate reservation documents (contracts, receipts, etc.)
  reservations.forEach(reservation => {
    const client = clients.find(c => c.id === reservation.clientId);
    const package_ = packages.find(p => p.id === reservation.forfaitId);
    
    // Contract document
    documents.push({
      id: `DOC-CONT-${reservation.id}`,
      nom: `Contrat_${reservation.destination.split(',')[0]}_${client?.nom || 'Client'}.pdf`,
      type: 'contrat',
      categorie: 'contrats',
      taille: `${Math.round(0.8 + Math.random() * 1.5)} MB`,
      dateCreation: reservation.dateReservation,
      proprietaire: client ? `${client.prenom} ${client.nom}` : reservation.clientNom,
      statut: reservation.statut === 'Confirmée' ? 'signé' : 'en_attente',
      description: `Contrat voyage ${reservation.destination} - ${package_?.titre || reservation.forfait}`,
      reference: {
        entite: 'Reservation',
        id: reservation.id
      }
    });
    
    // Receipt document
    if (reservation.acompte > 0) {
      documents.push({
        id: `DOC-RECU-${reservation.id}`,
        nom: `Recu_Paiement_${client?.nom || 'Client'}_${reservation.id}.pdf`,
        type: 'recu',
        categorie: 'factures',
        taille: `${Math.round(0.3 + Math.random() * 0.5)} MB`,
        dateCreation: reservation.dateReservation,
        proprietaire: client ? `${client.prenom} ${client.nom}` : reservation.clientNom,
        statut: 'validé',
        description: `Reçu paiement ${reservation.acompte === reservation.prixTotal ? 'complet' : 'acompte'} voyage ${reservation.destination}`,
        reference: {
          entite: 'Reservation',
          id: reservation.id
        }
      });
    }
    
    // Itinerary document
    if (reservation.statut === 'Confirmée') {
      documents.push({
        id: `DOC-ITIN-${reservation.id}`,
        nom: `Itineraire_${reservation.destination.split(',')[0]}_${client?.nom || 'Client'}.pdf`,
        type: 'itineraire',
        categorie: 'reservations',
        taille: `${Math.round(0.5 + Math.random())} MB`,
        dateCreation: reservation.dateReservation,
        proprietaire: client ? `${client.prenom} ${client.nom}` : reservation.clientNom,
        statut: 'validé',
        description: `Itinéraire détaillé pour ${reservation.destination}`,
        reference: {
          entite: 'Reservation',
          id: reservation.id
        }
      });
    }
  });
  
  // 3. Generate supplier documents (contracts, agreements, etc.)
  suppliers.forEach(supplier => {
    // Supplier contract
    documents.push({
      id: `DOC-SUP-${supplier.id}`,
      nom: `Contrat_Partenariat_${supplier.nom.replace(/\s+/g, '_')}.pdf`,
      type: 'contrat',
      categorie: 'fournisseurs',
      taille: `${Math.round(1 + Math.random() * 2)} MB`,
      dateCreation: supplier.datePartenariat,
      proprietaire: supplier.nom,
      statut: supplier.statut === 'Actif' ? 'actif' : 'archivé',
      description: `Contrat de partenariat avec ${supplier.nom}`,
      reference: {
        entite: 'Fournisseur',
        id: supplier.id
      }
    });
    
    // Service agreement
    documents.push({
      id: `DOC-SRV-${supplier.id}`,
      nom: `Accord_Services_${supplier.nom.replace(/\s+/g, '_')}.pdf`,
      type: 'contrat',
      categorie: 'fournisseurs',
      taille: `${Math.round(0.7 + Math.random() * 1.2)} MB`,
      dateCreation: supplier.datePartenariat,
      proprietaire: supplier.nom,
      statut: supplier.statut === 'Actif' ? 'actif' : 'archivé',
      description: `Accord de services avec ${supplier.nom} - Commission ${supplier.commission}%`,
      reference: {
        entite: 'Fournisseur',
        id: supplier.id
      }
    });
  });
  
  // 4. Generate package documents (brochures, pricing, etc.)
  packages.forEach(package_ => {
    // Package brochure
    documents.push({
      id: `DOC-PKG-${package_.id}`,
      nom: `Brochure_${package_.titre.replace(/\s+/g, '_')}.pdf`,
      type: 'marketing',
      categorie: 'marketing',
      taille: `${Math.round(2 + Math.random() * 14)} MB`,
      dateCreation: new Date(Date.now() - Math.random() * 15552000000).toISOString().split('T')[0], // Random date in last 180 days
      proprietaire: 'Service Marketing',
      statut: 'actif',
      description: `Brochure marketing pour ${package_.titre}`,
      reference: {
        entite: 'Forfait',
        id: package_.id
      }
    });
    
    // Package pricing
    documents.push({
      id: `DOC-PRICE-${package_.id}`,
      nom: `Tarifs_${package_.titre.replace(/\s+/g, '_')}.xlsx`,
      type: 'facture',
      categorie: 'finance',
      taille: `${Math.round(0.2 + Math.random() * 0.8)} MB`,
      dateCreation: new Date(Date.now() - Math.random() * 15552000000).toISOString().split('T')[0],
      proprietaire: 'Service Commercial',
      statut: 'actif',
      description: `Grille tarifaire pour ${package_.titre}`,
      reference: {
        entite: 'Forfait',
        id: package_.id
      }
    });
  });
  
  // 5. Generate administrative documents
  const adminDocs = [
    {
      id: 'DOC-ADM-001',
      nom: 'Licence_Agence_Voyage_2024.pdf',
      type: 'certificat',
      categorie: 'administratif',
      taille: '1.1 MB',
      dateCreation: '2024-01-01',
      proprietaire: 'Administration',
      statut: 'actif',
      description: 'Licence officielle agence de voyage 2024',
      reference: null
    },
    {
      id: 'DOC-ADM-002',
      nom: 'Assurance_Responsabilite_Civile.pdf',
      type: 'assurance',
      categorie: 'administratif',
      taille: '0.9 MB',
      dateCreation: '2024-01-15',
      proprietaire: 'Administration',
      statut: 'actif',
      description: 'Police d\'assurance responsabilité civile professionnelle',
      reference: null
    },
    {
      id: 'DOC-ADM-003',
      nom: 'Registre_Commerce.pdf',
      type: 'certificat',
      categorie: 'administratif',
      taille: '0.7 MB',
      dateCreation: '2023-12-10',
      proprietaire: 'Administration',
      statut: 'actif',
      description: 'Extrait du registre de commerce',
      reference: null
    }
  ];
  
  return [...documents, ...adminDocs];
};

export default {
  useReservationsData,
  useClientsData,
  usePackagesData,
  useFinancialData,
  useReservationsReportData,
  useDashboardData,
  useSidebarCounts,
  useSuppliersData,
  useBaseSuppliersData,
  useCalendarData,
  useDocumentsData // Add the new documents data service
}; 

// Reset localStorage to ensure fresh data on reload
// Added noReload parameter to avoid page reloads when just refreshing data
export const resetAndInitializeData = (noReload) => {
  console.log("Starting data initialization...");
  
  // Get existing data first to preserve it
  const existingClients = localStorage.getItem('clientsData');
  let clientsToUse = sampleClients;
  
  // If we have existing clients, use those instead of sample data
  if (existingClients) {
    try {
      const parsedClients = JSON.parse(existingClients);
      console.log("Preserving existing client data:", parsedClients.length, "clients");
      clientsToUse = parsedClients;
    } catch (e) {
      console.error("Error parsing existing client data, using sample data instead:", e);
    }
  } else {
    console.log("No existing client data found, using sample data");
  }
  
  // Process clients to ensure consistent ID types
  const normalizedClients = clientsToUse.map(client => ({
    ...client,
    id: client.id.toString() // Ensure IDs are strings for consistency
  }));
  
  // Process packages to ensure consistent ID types
  const normalizedPackages = samplePackages.map(pkg => ({
    ...pkg,
    id: Number(pkg.id),
    statut: pkg.statut || 'Actif'
  }));
  
  // Get existing reservations data or use sample data
  const existingReservations = localStorage.getItem('reservationsData');
  let reservationsToUse = sampleReservations;
  
  if (existingReservations) {
    try {
      const parsedReservations = JSON.parse(existingReservations);
      console.log("Preserving existing reservations data:", parsedReservations.length, "reservations");
      reservationsToUse = parsedReservations;
    } catch (e) {
      console.error("Error parsing existing reservations data, using sample data instead:", e);
    }
  } else {
    console.log("No existing reservations data found, using sample data");
  }
  
  // Process reservations to ensure consistent ID types and proper references
  const normalizedReservations = reservationsToUse.map(res => {
    // Convert IDs to numbers
    const clientId = Number(res.clientId);
    const forfaitId = Number(res.forfaitId);
    
    // Get client and package references
    const client = normalizedClients.find(c => c.id === clientId);
    const forfait = normalizedPackages.find(p => p.id === forfaitId);
    
    // Build a properly linked reservation object
    return {
      ...res,
      clientId,
      forfaitId,
      clientNom: res.clientNom || (client ? `${client.prenom} ${client.nom}` : 'Client inconnu'),
      forfait: res.forfait || (forfait ? forfait.titre : 'Forfait inconnu')
    };
  });
  
  // Now enhance packages with reservation counts
  const enhancedPackages = normalizedPackages.map(pkg => {
    const packageId = Number(pkg.id);
    
    // Find related reservations
    const relatedReservations = normalizedReservations.filter(res => 
      Number(res.forfaitId) === packageId
    );
    
    // Find clients who booked this package
    const relatedClients = normalizedClients.filter(client =>
      relatedReservations.some(res => Number(res.clientId) === Number(client.id))
    );
    
    return {
      ...pkg,
      reservations: relatedReservations,
      reservationCount: relatedReservations.length,
      clients: relatedClients,
      clientCount: relatedClients.length
    };
  });
  
  // Always initialize localStorage with the latest processed data
  // This ensures data is always up to date across all components
  localStorage.setItem('packagesData', JSON.stringify(enhancedPackages));
  
  // Dispatch event to notify other components
  window.dispatchEvent(new CustomEvent('packageDataRefresh', {
    detail: { packages: enhancedPackages }
  }));
  
  // Always update reservations data for real-time consistency
  localStorage.setItem('reservationsData', JSON.stringify(normalizedReservations));
  
  // Dispatch event to notify other components
  window.dispatchEvent(new CustomEvent('reservationDataRefresh', {
    detail: { reservations: normalizedReservations }
  }));
  
  // Always update clients data to ensure it's consistent
  localStorage.setItem('clientsData', JSON.stringify(normalizedClients));
  
  // Dispatch event to notify other components
  window.dispatchEvent(new CustomEvent('clientDataRefresh', {
    detail: { clients: normalizedClients }
  }));
  
  // Create a dataCache object if it doesn't exist
  if (typeof window.dataCache === 'undefined') {
    window.dataCache = {};
  }
  
  // Update cache timestamps
  window.dataCache.packages = { data: enhancedPackages, timestamp: Date.now() };
  window.dataCache.reservations = { data: normalizedReservations, timestamp: Date.now() };
  window.dataCache.clients = { data: normalizedClients, timestamp: Date.now() };
  
  console.log("Data reset complete with normalized IDs and relationships");
  console.log("Enhanced packages with client data:", enhancedPackages);
  
  // Increment all global data versions to force cache invalidation
  Object.keys(globalDataVersion).forEach(key => {
    globalDataVersion[key]++;
  });
  
  // Update all cache entries with new versions
  Object.keys(dataCache).forEach(key => {
    if (dataCache[key] && dataCache[key].data) {
      dataCache[key].version = globalDataVersion[key];
      dataCache[key].timestamp = Date.now();
    }
  });
  
  // Broadcast a global data refresh event for all components to update
  window.dispatchEvent(new CustomEvent('globalDataRefresh', {
    detail: {
      timestamp: Date.now(),
      source: 'resetAndInitializeData',
      allVersions: {...globalDataVersion}
    }
  }));

  // Only reload the page if not explicitly told not to (and not in development mode)
  if (noReload !== 'noReload') {
    console.log('Triggering data refresh events');
    // Instead of reloading, notify all components to update with specific data
    setTimeout(() => {
      // Dispatch specific events for components that listen for them
      window.dispatchEvent(new CustomEvent('financialDataUpdate', {
        detail: { refreshType: 'full', source: 'resetAndInitializeData' }
      }));
      window.dispatchEvent(new CustomEvent('reportDataUpdate', {
        detail: { refreshType: 'full', source: 'resetAndInitializeData' }
      }));
      
      // Force dashboard update
      window.dispatchEvent(new CustomEvent('dashboardUpdate', {
        detail: { refreshType: 'full', source: 'resetAndInitializeData' }
      }));
      
      // Dispatch version change events for each data type
      Object.keys(globalDataVersion).forEach(key => {
        window.dispatchEvent(new CustomEvent('dataVersionChange', {
          detail: { key, version: globalDataVersion[key], source: 'resetAndInitializeData' }
        }));
      });
    }, 100);
  }
  
  return {
    packages: enhancedPackages,
    reservations: normalizedReservations,
    clients: normalizedClients
  };
}; 
